import { LOCALES } from "../constants";

const fi = {
  [LOCALES.FI]: {
    //All page
    "Página não encontrada": "Sivua ei löytynyt",
    //LOGIN PAGE
    "login.Login": "Kirjaudu",
    "login.Informe seu e-mail": "Anna sähköpostiosoitteesi",
    "login.E-mail inválido. Por favor, verifique":
    "Virheellinen sähköpostiosoite. Tarkista tiedot.",
    "login.Senha": "Salasana",
    "login.Sua senha deve possuir no mínimo 6 caracteres":
    "Salasanassa on oltava vähintään 6 merkkiä",
    "login.Esqueci minha senha": "Unohdin salasanani",
    "login.ENTRAR": "KIRJAUDU",
    "login.CRIAR CONTA": "LUO TILI",
    "login.Não foi possÍvel fazer o login. Verifique seus dados e tente novamente":
    "Kirjautuminen epäonnistui. Tarkista tietosi ja yritä uudelleen.",
    "login.A PLATAFORMA IOK MUDOU!": "IOK-ALUSTA ON UUDISTUNUT!",
    "login.Não exibir este aviso novamente": "Älä näytä tätä ilmoitusta uudelleen",
    "login.Se você já possui um cadastro na antiga plataforma, ": "Jos sinulla on jo tili vanhalla alustalla, ",
    "login.clique aqui": "napsauta tästä",
    "login. para": " ",
    "login.migrar": "siirtääksesi ",
    "login.seus dados e aproveitar toda a experiência IOK.": "tietosi ja hyödyntääksesi koko IOK-kokemuksen.",
    "login.Sua conta não foi ativada. Por gentileza, verifique seu e-mail para realizar a ativação": "Tiliäsi ei ole aktivoitu. Tarkista sähköpostisi aktivoidaksesi tilin.",
    "login.PLATAFORMA EM MANUTENÇÃO": "ALUSTAA HUOLLETAAN",
    "login.ESTAMOS PREPARANDO A NOVA PLATAFORMA IOK E EM BREVE ELA ESTARÁ PRONTA!": "VALMISTELEMME UUTTA IOK-ALUSTAA. SE ON PIAN VALMIS!",
    "login.Migrar Conta": "Siirrä tili",
    "login.Se você já possui um cadastro na antiga plataforma, clique aqui em Migrar Conta para migrar seus dados e aproveitar toda a experiência IOK": "Jos sinulla on jo tili vanhalla alustalla, napsauta Siirrä tili siirtääksesi tietosi ja hyödyntääksesi koko IOK-kokemuksen.",
    "login.Política de privacidade": "Tietosuojakäytäntö",
    "login.ENTENDI": "YMMÄRSIN",
    "login.Para melhorar a sua experiência na plataforma e oferecer serviços personalizados, utilizamos cookies.": "Parantaaksemme käyttökokemustasi alustalla ja tarjotaksemme personoituja palveluita käytämme evästeitä.",
    "login.Ao utilizar a Plataforma IOK, você automaticamente concorda com seu uso.": "Käyttämällä IOK-alustaa hyväksyt automaattisesti evästeiden käytön.",
    "login.Senha incorreta! Duas tentativas restantes antes de ter o acesso à conta bloqueado.": "Virheellinen salasana! Sinulla on vielä kaksi yritystä ennen kuin tilisi käyttö estetään.",
    "login.Senha incorreta! Uma tentativa restantes antes de ter o acesso à conta bloqueado.": "Virheellinen salasana! Sinulla on vielä yksi yritys ennen kuin tilisi käyttö estetään.",
    "login.Acesso bloqueado! Siga as instruções de recuperação de conta.": "Käyttö estetty! Noudata tilin palautusohjeita.",
    
    // REGISTER
    "DISTRIBUIDOR": "JAKELIJA:Olen Prática-laitteiden jakelija.",
    "REDE": "VERKOSTO:Olen verkoston omistaja.",
    "DONO": "YRITYS:Minulla on oma yritys / kuulun verkostoon.",
    "register.Informe seu e-mail cadastrado na plataforma IOK anterior": "Anna edelliselle IOK-alustalle rekisteröity sähköpostiosoitteesi",
    "register.E-mail inválido. Por favor, verifique": "Virheellinen sähköpostiosoite. Tarkista tiedot.",
    "register.BUSCAR DADOS": "HAE TIEDOT",
    "register.Nome da organização": "Organisaation nimi",
    "register.Informe o nome de sua organização": "Anna organisaatiosi nimi",
    "register.O campo nome da organização é obrigatório": "Organisaation nimi on pakollinen",
    "register.Este nome já existe. Por favor, escolha outro": "Tämä nimi on jo käytössä. Valitse toinen.",
    "register.RECUPERAR CONTA": "PALAUTA TILI",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA DE USUÁRIO. POR GENTILIZA, AGUARDE": "ORGANISAATION YLLÄPITÄJÄ SAA SÄHKÖPOSTIN KÄYTTÄJÄTILISI AKTIVOIMISEKSI. OLE HYVÄ JA ODOTA.",
    "register.E-mail não encontrado": "Sähköpostiosoitetta ei löytynyt",
    "register.Digite seu e-mail da plataforma IOK antiga": "Anna vanhan IOK-alustan sähköpostiosoitteesi",
    "register.Não foi possível recuperar sua conta. Verifique seus dados e tente novamente": "Tilin palauttaminen epäonnistui. Tarkista tietosi ja yritä uudelleen.",
    "register.Não foi possível recuperar seus dados. Verifique e tente novamente": "Tietojen palauttaminen epäonnistui. Tarkista tiedot ja yritä uudelleen.",
    "register.PROSSEGUIR": "JATKA",
    "register.VOCÊ ESTÁ SOLICITANDO ACESSO PARA A ORGANIZAÇÃO:": "PYYDÄT KÄYTTÖOIKEUTTA ORGANISAATIOON: ",
    "register.COM O ADMINISTRADOR:": " YLLÄPITÄJÄNÄ: ",
    "register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado": "Sähköpostiosoite on jo rekisteröity alustalle. Anna uusi sähköpostiosoite tai kirjaudu sisään jo rekisteröidyllä osoitteella.",
    "register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa": "Yritys on jo rekisteröity alustalle. Anna uuden yrityksen nimi.",
    "register.VOCÊ NÃO RECONHECEU O USUÁRIO {userName} COMO PARTE DA SUA ORGANIZAÇÃO E POR ISSO A CONTA DELE FOI DELETADA.": "ET TUNNISTANUT KÄYTTÄJÄÄ {userName} OSAKSI ORGANISAATIOTASI, JOTEN HÄNEN TILINSÄ POISTETTIIN.",
    "register.NÂO FOI POSSÍVEL DELETAR O USÁRIO {userName}. POR GENTILEZA, TENTE NOVAMENTE MAIS TARDE.": "KÄYTTÄJÄÄ {userName} EI VOITU POISTAA. YRITÄ UUDELLEEN MYÖHEMMIN.",
    "register.CONFIRMAR": "VAHVISTA",
    "register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente":
    "Rekisteröinti epäonnistui. Tarkista tietosi ja yritä uudelleen.",
    "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR":
    "SAAT SÄHKÖPOSTIN REKISTERÖINNIN VIIMEISTELEMISEKSI JA YLLÄPITÄJÄTILISI AKTIVOIMISEKSI.",
    "register.Nome": "Nimi",
    "register.Informe seu nome": "Anna nimesi",
    "register.O campo nome é obrigatório": "Nimi on pakollinen.",
    "register.E-mail": "Sähköposti",
    "register.Informe seu e-mail": "Anna sähköpostiosoitteesi",
    "register.E-mail inválido. Por favor, verifique novamente":
    "Virheellinen sähköpostiosoite. Tarkista tiedot uudelleen.",
    "register.Telefone": "Puhelin",
    "register.Informe seu telefone": "Anna puhelinnumerosi",
    "register.Crie sua senha": "Luo salasana",
    "register.Informe sua senha": "Anna salasanasi",
    "register.O campo senha deve conter no mínimo 6 caracteres":
    "Salasanassa on oltava vähintään 6 merkkiä.",
    "register.Confirme sua senha": "Vahvista salasanasi",
    "register.As senhas devem ser iguais": "Salasanojen on oltava samat",
    "register.CRIAR CONTA": "LUO TILI",
    "register.CONTA ATIVADA COM SUCESSO": "TILI AKTIVOITU ONNISTUNEESTI",
    "register.ACESSAR": "SIIRRY",
    "register.NÃO FOI POSSÍVEL ATIVAR SUA CONTA":
    "TILIÄSI EI VOITU AKTIVOIDA",
    "register.Digite seu telefone": "Anna puhelinnumerosi",
    "register.AGUARDE ENQUANTO TRANSFERIMOS SEUS DADOS. ESTE PROCESSO DEVE LEVAR ALGUNS MINUTOS. CASO VOCÊ POSSUA UMA GRANDE QUANTIDADE DE DADOS, A TRANSFERÊNCIA PODE LEVAR ATÉ UMA HORA.": "ODOTA, KUN SIIRRÄMME TIETOJASI. TÄMÄ PROSESSI KESTÄÄ MUUTAMAN MINUUTIN. JOS SINULLA ON SUURI MÄÄRÄ TIETOJA, SIIRTO VOI KESTÄÄ JOPA TUNNIN.",
    "register.DADOS TRANSFERIDOS COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "TIEDOT ON SIIRRETTY ONNISTUNEESTI! SIIRRY ALUSTALLE NAPSAUTTAMALLA ALLA OLEVAA PAINIKETTA.",
    "register.EMAIL INVÁLIDO. POR GENTILEZA, VERIFIQUE SE SUA CONTA JÁ FOI ATIVADA.": "VIRHEELLINEN SÄHKÖPOSTIOSOITE. TARKISTATHAN, ONKO TILISI JO AKTIVOITU.",
    "register.Ainda não tenho uma organização. Criar": "Minulla ei vielä ole organisaatiota. Luo",
    "register.Informe o ID da organização": "Anna organisaation tunnus",
    "register.O campo com ID é obrigatório": "ID-kenttä on pakollinen",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE": "ORGANISAATION YLLÄPITÄJÄ SAA SÄHKÖPOSTIN TILISI AKTIVOIMISEKSI. OLE HYVÄ JA ODOTA.",
    "register.A nova plataforma IOK agora está dividida em organizações e possui diferentes tipos de conta, que ajudam a organizar melhor as grandes corporações, empresas e redes.": "Uusi IOK-alusta on nyt jaettu organisaatioihin, ja siinä on erilaisia tilityyppejä, jotka helpottavat suuryritysten, yritysten ja verkostojen hallintaa.",
    "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário.": "Organisaationi ylläpitäjä on jo siirtänyt tilin, ja meillä on tunnus. Haluan siirtää käyttäjätietoni.",
    "register.Desejo migrar a conta da minha organização e me tornar o administrador.": "Haluan siirtää organisaationi tilin ja ryhtyä sen ylläpitäjäksi.",
    "register.Conta da organização já migrada": "Organisaation tili on jo siirretty",
    "register.Migrar conta da organização": "Siirrä organisaation tili",
    "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido.": "Uudessa IOK-alustassa on nyt uusia käyttöoikeustapoja, jotka riippuvat organisaatiotyypistäsi. Organisaatiostasi vastaavan henkilön tulee siirtää yrityksen päätili ja toimia ylläpitäjänä, kun taas muiden työntekijöiden tulee liittyä siihen annetun tunnuksen avulla.",
    "register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente": "Annettu tunnus ei vastaa mitään yritystä. Tarkista tiedot ja yritä uudelleen.",
    "register.VOCÊ POSSUI MUITOS MENUS, NÃO CONSEGUIMOS REALIZAR A IMPORTAÇÃO AUTOMÁTICA. SUA CONTA SERÁ ATIVADA, PORÉM OS MENUS PRECISARÃO SER MIGRADOS MANUALMENTE.": "SINULLA ON LIIAN PALJON VALIKOITA, EMMEKÄ VOINEET SUORITTAA AUTOMAATTISTA TUONTIA. TILISI AKTIVOIDAAN, MUTTA VALIKOT ON SIIRRETTÄVÄ MANUAALISESTI.",
    "register.PARA MIGRAR SEUS MENUS, APÓS O LOGIN, CLIQUE NO SEU NOME NO CANTO SUPERIOR DIREITO, CLIQUE EM EDITAR CONTA E DEPOIS EM IMPORTAR MENUS.": "SIIRTÄÄKSESI VALIKKOSI KIRJAUDU SISÄÄN, NAPSAUTA NIMEÄSI OIKEASTA YLÄKULMASTA, VALITSE MUOKKAA TILIÄ JA SEN JÄLKEEN TUO VALIKOT.",
    "register.Atenção:": "Huomio:",
    "register.apenas uma pessoa da organização pode criar a conta e, depois de ativá-la, convidar os demais usuários da empresa para acessá-la.": "Vain yksi henkilö organisaatiosta voi luoda tilin ja sen aktivoinnin jälkeen kutsua muut yrityksen käyttäjät käyttämään sitä.",
    "register.TOKEN DESENVOLVEDOR CANCELADO": "KEHITTÄJÄTUNNUS PERUUTETTU",
    "register.Sua senha deve estar entre 8 e 20 caracteres, ter uma letra maiúscula, uma minúscula, um número e um caractere especial": "Salasanan on oltava 8–20 merkkiä pitkä ja sisällettävä yksi iso kirjain, yksi pieni kirjain, yksi numero ja yksi erikoismerkki.",
    
    //HOME
    "home.Menus disponíveis na plataforma": "Alustalla saatavilla olevat valikot",
    "home.Criados na plataforma": "Alustalla luodut",
    "home.Recebidos dos fornos": "Uuneista vastaanotetut",
    "home.Equipamentos vinculados": "Liitetyt laitteet",
    "home.Total de receitas cadastradas": "Rekisteröityjen reseptien kokonaismäärä",
    "home.Receitas": "Reseptit",
    "home.Receitas em menus": "Valikoissa olevat reseptit",
    "home.Em menus": "Valikoissa",
    "home.Receitas salvas no Cookbook": "Cookbookiin tallennetut reseptit",
    "home.No Cookbook": "Cookbookissa",
    "home.Atualizações": "Päivitykset",
    "home.Copa": "Copa",
    "home.Rocket": "Rocket",
    "home.Single Mag": "Single Mag",
    "home.Versão instalada": "Asennettu versio",
    "home.Versão disponível": "Saatavilla oleva versio",
    "home.Usuários cadastrados": "Rekisteröidyt käyttäjät",
    "home.Aceitação pendente": "Hyväksyntä odottaa",
    "home.Atualizado": "Päivitetty",
    "home.OLÁ": "TERVETULOA",
    "home.É muito bom ter você aqui!": "Mukava nähdä sinut täällä!",
    "home.Com a Plataforma IOK é possível administrar seus fornos de onde estiver, criar e gerenciar receitas e menus, fazer backups, analisar os dados de seus equipamentos e muito mais!": "IOK-alustalla voit hallita uunejasi mistä tahansa, luoda ja hallita reseptejä ja valikoita, tehdä varmuuskopioita, analysoida laitteidesi tietoja ja paljon muuta!",
    "home.Conheça a plataforma": "Tutustu alustaan",
    "home.Taxa de erro por modelo": "Virheiden määrä mallin mukaan",
    "home.Erro": "Virhe",
    "home.QUEREMOS SABER SUA OPINIÃO SOBRE": "HALUAMME KUULLA MIELIPITEESI AIHEESTA",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a Plataforma {model} foi criado!": "Arvostamme suuresti mielipidettäsi, ja siksi olemme laatineet tämän tyytyväisyyskyselyn alustasta {model}!",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a linha {model} foi criado!": "Arvostamme suuresti mielipidettäsi, ja siksi olemme laatineet tämän tyytyväisyyskyselyn tuotesarjasta {model}!",
    "home.Suas respostas nos ajudarão a aprimorar nossos serviços, garantindo que continuemos a oferecer a você a melhor experiência possível.": "Vastauksesi auttavat meitä parantamaan palveluitamme ja varmistamaan, että voimme tarjota sinulle parhaan mahdollisen käyttökokemuksen.",
    "home.Reserve uns minutinhos de seu dia e participe!": "Varaa muutama minuutti päivästäsi ja osallistu!",
    "home.Responder a pesquisa": "Vastaa kyselyyn",
    "home.Modelos em evidência": "Esillä olevat mallit",
    "home.Modelos": "Mallit",
    "home.Total de equipamentos vinculados": "Liitettyjen laitteiden kokonaismäärä",
    "home.Total de equipamentos online": "Verkossa olevien laitteiden kokonaismäärä",
    "home.Equipamentos online": "Verkossa olevat laitteet",
    "home.Países com Prática": "Prática-maat",
    "home.Países": "Maat",
    "home.Aguarde enquanto carregamos os dados": "Odota, kun lataamme tietoja",
    "home.Quase lá! Aguarde um pouco mais": "Melkein valmista! Odota vielä hetki",
    "home.Vendas por Equipamento": "Myynti laitteittain",
    "home.Total de equipamentos vendidos": "Myytyjen laitteiden kokonaismäärä",
    "home.Equipamentos vendidos": "Myydyt laitteet",
    "home.Clique para atualizar o software": "Päivitä ohjelmisto napsauttamalla",
    "home.Aceitação de software pendente": "Ohjelmiston hyväksyntä odottaa",
    "home.Software atualizado": "Ohjelmisto päivitetty",
    "home.NENHUM EQUIPAMENTO VINCULADO": "EI LIITETTYJÄ LAITTEITA",
    "home.FORNOS LIGADOS": "PÄÄLLÄ OLEVAT UUNIT",
    "home.Enviando dados": "Lähettää tietoja",
    "home.Com conectividade IOK": "IOK-yhteydellä",
    "home.Sem envio de dados": "Ei lähetä tietoja",
    "home.Sem conectividade IOK": "Ei IOK-yhteyttä",
    "home.Criados na Plataforma": "Luotu alustalla",
    "home.Apenas no Cookbook": "Vain Cookbookissa",
    "home.Usuários na companhia": "Yrityksen käyttäjät",
    "home.Inativos": "Ei aktiiviset",
    "home.Online": "Verkossa",
    "home.Atualizações de equipamentos": "Laitepäivitykset",
    "home.Modelos de equipamentos": "Laitemallit",
    "home.Atualizados": "Päivitetyt",
    "home.Aguardando Aceite": "Odottaa hyväksyntää",
    "home.Desatualizados": "Vanhentuneet",
    
    //MAIN
    "main.HOME": "ETUSIVU",
    "main.COOKBOOK": "COOKBOOK",
    "main.MEUS MENUS": "OMAT VALIKOT",
    "main.EQUIPAMENTOS": "LAITTEET",
    "main.USUÁRIOS": "KÄYTTÄJÄT",
    "main.ATENDIMENTOS": "HUOLTOTAPAUKSET",
    "main.Idioma": "Kieli",
    "main.Editar conta": "Muokkaa tiliä",
    "main.Configurações": "Asetukset",
    "main.Sair": "Kirjaudu ulos",
    "main.Configurações salvas com sucesso!": "Asetukset tallennettu onnistuneesti!",
    "main.SALVAR": "TALLENNA",
    "main.CONFIGURAÇÕES": "ASETUKSET",
    "main.Tema dark": "Tumma teema",
    "main.Notificações": "Ilmoitukset",
    "main.Informações para as receitas": "Reseptiasetukset",
    "main.Peso:": "Paino:",
    "main.Gramas": "Grammaa",
    "main.Oz": "Oz",
    "main.Temperatura:": "Lämpötila:",
    "main.Fahrenheit (°F)": "Fahrenheit (°F)",
    "main.Conta editada com sucesso!": "Tili päivitetty onnistuneesti!",
    "main.EDITAR CONTA": "MUOKKAA TILIÄ",
    "main.Nome": "Nimi",
    "main.Preencha com o seu nome": "Anna nimesi",
    "main.Telefone": "Puhelin",
    "main.Preencha com o seu telefone": "Anna puhelinnumerosi",
    "main.E-mail": "Sähköposti",
    "main.Preencha com o seu e-mail": "Anna sähköpostiosoitteesi",
    "main.Alterar Senha": "Vaihda salasana",
    "main.ALTERAR SENHA": "VAIHDA SALASANA",
    "main.Senha atual": "Nykyinen salasana",
    "main.Nova senha": "Uusi salasana",
    "main.Confirmar nova senha": "Vahvista uusi salasana",
    "main.Informe sua senha atual": "Anna nykyinen salasanasi",
    "main.O campo senha deve conter no mínimo 6 caracteres":
    "Salasanassa on oltava vähintään 6 merkkiä",
    "main.Informe sua nova senha": "Anna uusi salasanasi",
    "main.Confirme sua nova senha": "Vahvista uusi salasanasi",
    "main.Sua nova senha deve conter no mínimo 6 caracteres":
    "Uuden salasanasi on oltava vähintään 6 merkkiä pitkä",
    "main.INFORME SUA SENHA": "ANNA SALASANASI",
    "main.Informe sua senha para realizar a alteração de e-mail da plataforma:":
    "Anna salasanasi vaihtaaksesi alustan sähköpostiosoitteen:",
    "main.CONFIRMAR": "VAHVISTA",
    "main.Existem campos que não foram preenchidos corretamente":
    "Joitakin kenttiä ei ole täytetty oikein",
    "main.Informe sua senha para prosseguir com a alteração de e-mail":
    "Anna salasanasi jatkaaksesi sähköpostiosoitteen vaihtoa",
    "main.Senha alterada com sucesso": "Salasana vaihdettu onnistuneesti",
    "main.Informe sua senha atual corretamente": "Anna nykyinen salasanasi oikein",
    "main.As senhas devem ser iguais": "Salasanojen on oltava samat",
    "main.Nome do novo tipo de usuário": "Uuden käyttäjätyypin nimi",
    "main.Dê um nome para o novo tipo de usuário": "Anna uudelle käyttäjätyypille nimi",
    "main.Token Desenvolvedor": "Kehittäjätunnus",
    "main.O Token Desenvolvedor é um código único e intransferível que permite a realização de alterações": "Kehittäjätunnus on yksilöllinen ja henkilökohtainen tunnus, jonka avulla voidaan tehdä kehitystason muutoksia suoraan alustan lähdekoodiin ulkoisten API-rajapintojen kautta. Näin alustaa voidaan mukauttaa paremmin yrityksesi tarpeisiin.",
    "main.É recomendado que estas alterações sejam realizadas por um profissional da área de tecnologia": "On suositeltavaa, että nämä muutokset tekee teknologia-alan ammattilainen.",
    "main.Para acessar o token, informe sua senha": "Anna salasanasi nähdäksesi tunnuksen",
    "main.Copie e cole o token na autenticação de todas as requisições.": "Kopioi ja liitä tunnus kaikkien pyyntöjen todennukseen.",
    "main.Seu Token": "Tunnuksesi",
    "main.review.download": "Avaa käyttöohje",
    
    //MEUS MENUS
    "menus.Procurar menu": "Etsi valikkoa tai käyttäjää",
    "menus.Procurar menu excluído": "Etsi poistettua valikkoa",
    "menus.Menus": "Valikot",
    "menus.Lixeira": "Roskakori",
    "menus.CRIAR MENU": "LUO VALIKKO",
    "menus.IMPORTAR MENU": "TUO VALIKKO",
    "menus.Os arquivos serão mantidos na lixeira por 30 dias a contar de sua data de exclusão. Após este período, eles serão excluídos definitivamente.":
    "Tiedostot säilytetään roskakorissa 30 päivää niiden poistopäivästä. Tämän ajan jälkeen ne poistetaan pysyvästi.",
    "menus.VOLTAR": "takaisin",
    "menus.Compatível com: ": "Yhteensopiva: ",
    "menus.Última atualização: ": "Viimeisin päivitys: ",
    "menus.EXPORTAR MENU": "VIE VALIKKO",
    "menus.EDITAR MENU": "MUOKKAA VALIKKOA",
    "menus.Equipamentos associados": "Liitetyt laitteet",
    "menus.Grupos": "Ryhmät",
    "menus.Procurar grupo": "Etsi ryhmää",
    "menus.CRIAR GRUPO": "LUO RYHMÄ",
    "menus.receitas": "reseptiä",
    "menus.Nenhum grupo cadastrado": "Ryhmiä ei ole rekisteröity",
    "menus.Nenhum menu cadastrado": "Valikkoja ei ole rekisteröity",
    "menus.Nome": "Nimi",
    "menus.Modelo": "Malli",
    "menus.Atividade": "Toiminta",
    "menus.Associação": "Liitos",
    "menus.Exportar": "Vie",
    "menus.Editar": "Muokkaa",
    "menus.Excluir": "Poista",
    "menus.Equips": "Laitteet",
    "menus.Receitas": "Reseptit",
    "menus.Compatibilidade": "Yhteensopivuus",
    "menus.Última atualização": "Viimeisin päivitys",
    "menus.Versão": "Versio",
    "menus.Origem": "Alkuperä",
    "menus.Excluído por": "Poistanut",
    "menus.Data de exclusão": "Poistopäivä",
    "menus.Restaurar": "Palauta",
    "menus.Existem campos que não foram preenchidos":
    "Joitakin kenttiä ei ole täytetty",
    "menus.Menu criado com sucesso!": "Valikko luotu onnistuneesti!",
    "menus.Existem campos com informações inválidas":
    "Joissakin kentissä on virheellisiä tietoja",
    "menus.SALVAR": "TALLENNA",
    "menus.CANCELAR": "PERUUTA",
    "menus.Nome do menu": "Valikon nimi",
    "menus.Informe o nome do menu": "Anna valikon nimi",
    "menus.Preencha o nome do menu sem caracteres especiais": "Anna valikon nimi ilman erikoismerkkejä",
    "menus.Apenas os caracteres @#%&*-+()!\"<>:;\\/?. são permitidos": "Vain merkit @#%&*-+()!\"<>:;\\/?. ovat sallittuja",
    "menus.Selecionar": "Valitse",
    "menus.Idioma": "Kieli",
    "menus.Temperatura de pré-aquec 1": "Esilämmityslämpötila 1",
    "menus.Informe a temperatura de pré-aquec 1":
    "Anna esilämmityslämpötila 1",
    "menus.Temperatura de pré-aquec 2": "Esilämmityslämpötila 2",
    "menus.Informe a temperatura de pré-aquec 2":
    "Anna esilämmityslämpötila 2",
    "menus.Tempo para estabilização": "Vakautumisaika",
    "menus.Informe o tempo para estabilização":
    "Anna vakautumisaika",
    "menus.Desativar pré-aquec 2": "Poista esilämmitys 2 käytöstä",
    "menus.Configurações de data e hora": "Päivämäärä- ja aika-asetukset",
    "menus.Data:": "Päivämäärä:",
    "menus.DD/MM/AAAA": "PP/KK/VVVV",
    "menus.Hora:": "Aika:",
    "menus.24h": "24 h",
    "menus.AM/PM": "AM/PM",
    "menus.EUR: DD/MM/AAAA": "EUR: PP/KK/VVVV",
    "menus.USA: MM/DD/AAAA": "USA: KK/PP/VVVV",
    "menus.ISO: AAAA/MM/DD": "ISO: VVVV/KK/PP",
    "menus.Seleção de acessos para habilitar":
    "Valitse käyttöoikeudet, jotka otetaan käyttöön",
    "menus.Modo manual": "Manuaalinen tila",
    "menus.Habilitado": "Käytössä",
    "menus.Desabilitado": "Pois käytöstä",
    "menus.Favoritos": "Suosikit",
    "menus.Aquecer/Dourar": "Lämmitä/Ruskista",
    "menus.Repetir receita": "Toista resepti",
    "menus.Configurações gerais do menu": "Valikon yleiset asetukset",
    "menus.Temperatura:": "Lämpötila:",
    "menus.Fahrenheit (°F)": "Fahrenheit (°F)",
    "menus.Gramas": "Grammaa",
    "menus.Oz": "Unssia",
    "menus.Tema:": "Teema:",
    "menus.Dark": "Tumma",
    "menus.Light": "Vaalea",
    "menus.Introdução:": "Johdanto:",
    "menus.Ativada": "Käytössä",
    "menus.Desativada": "Pois käytöstä",
    "menus.Menu deletado com sucesso!": "Valikko poistettu onnistuneesti!",
    "menus.Não foi possivel deletar o menu": "Valikkoa ei voitu poistaa",
    "menus.Sim": "Kyllä",
    "menus.Não": "Ei",
    "menus.Excluir definitivamente": "Poista pysyvästi",
    "menus.SALVAR NO DISPOSITIVO": "TALLENNA LAITTEESEEN",
    "menus.EXPORTAR": "VIE",
    "menus.Selecione os modelos e versões dos equipamentos que receberão o menu.":
    "Valitse niiden laitteiden mallit ja versiot, joihin valikko viedään.",
    "menus.Forno": "Uuni",
    "menus.Fundo verde": "Vihreä tausta",
    "menus.Fundo preto": "Musta tausta",
    "menus.Linux": "Linux",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, exceto para menus de equipamentos Linux.":
    "Huomio: ennen kuin siirrät valikon USB-muistitikulta laitteeseen, tiedosto on purettava, paitsi Linux-laitteiden valikoiden osalta.",
    "menus.Selecione os equipamentos para os quais deseja exportar o menu.":
    "Valitse laitteet, joihin haluat viedä valikon.",
    "menus.Nome do equipamento": "Laitteen nimi",
    "menus.Selecionar todos": "Valitse kaikki",
    "menus.Selecionar todas": "Valitse kaikki",
    "menus.Categoria: ": "Luokka: ",
    "menus.Você deseja excluir o menu?": "Haluatko poistaa valikon?",
    "menus.O menu será deletado da plataforma, mas permanecerá no equipamento. Uma cópia de segurança será criada automaticamente e ficará disponível por 30 dias em Meus Menus - Lixeira.":
    "Valikko poistetaan alustalta, mutta se säilyy laitteessa. Varmuuskopio luodaan automaattisesti, ja se on käytettävissä 30 päivän ajan kohdassa Omat valikot - Roskakori.",
    "menus.Você deseja excluir o arquivo definitivamente?":
    "Haluatko poistaa tiedoston pysyvästi?",
    "menus.Esta ação não poderá ser desfeita.":
    "Tätä toimintoa ei voi kumota.",
    "menus.Menu editado com sucesso!": "Valikkoa muokattu onnistuneesti!",
    "menus.IMPORTAR": "TUO",
    "menus.VERIFICAÇÃO DE VERSÃO": "VERSION TARKISTUS",
    "menus.Para conferir a versão da placa de seu equipamento, siga os seguintes passos:":
    "Tarkistaaksesi laitteesi kortin version noudata seuraavia vaiheita:",
    "menus.No forno, acesse Configurações;": "Siirry uunissa kohtaan Asetukset;",
    "menus.Insira a senha 456789;": "Anna salasana 456789;",
    "menus.Selecione a opção Sistema;": "Valitse vaihtoehto Järjestelmä;",
    "menus.Selecione Informações do Fabricante;":
    "Valitse Valmistajan tiedot;",
    "menus.O modelo de sua placa estará na linha Firmware IHM;":
    "Korttisi malli näkyy rivillä IHM-laiteohjelmisto;",
    "menus.1ª geração A": "1. sukupolvi A",
    "menus.Firmware IHM: 12.3.4": "IHM-laiteohjelmisto: 12.3.4",
    "menus.1ª geração B": "1. sukupolvi B",
    "menus.2ª geração/Linux:": "2. sukupolvi/Linux:",
    "menus.Firmware IHM: L1.2.3": "IHM-laiteohjelmisto: L1.2.3",
    "menus.Selecione o modelo/versão do equipamento do qual deseja importar o menu. Saiba como conferir a versão de seu equipamento":
    "Valitse sen laitteen malli/versio, josta haluat tuoda valikon. Katso, kuinka tarkistat laitteesi version ",
    "menus.Como verificar a versão da placa":
    "Kuinka tarkistaa kortin versio",
    "menus.1° Geração": "1. sukupolvi",
    "menus.Menu restaurado com sucesso!": "Valikko palautettu onnistuneesti!",
    "menus.Não foi possivel restaurar o menu":
    "Valikkoa ei voitu palauttaa",
    "menus.RESTAURAR ARQUIVO": "PALAUTA TIEDOSTO",
    "menus.Você deseja restaurar o arquivo?":
    "Haluatko palauttaa tiedoston?",
    "menus.O arquivo será restaurado como uma nova versão na plataforma, na guia Todos. Para salvá-lo no equipamento, exporte-o.":
    "Tiedosto palautetaan uutena versiona alustalle Kaikki-välilehdelle. Tallentaaksesi sen laitteeseen vie se.",
    "menus.EXCLUIR MENU": "POISTA VALIKKO",
    "menus.Nenhum equipamento associado": "Ei liitettyjä laitteita",
    "menus.Nomeie o novo menu": "Anna uudelle valikolle nimi",
    "menus.Nomeie o novo grupo": "Anna uudelle ryhmälle nimi",
    "menus.Nome do grupo": "Ryhmän nimi",
    "menus.Preencha o nome do grupo sem caracteres especiais": "Anna ryhmän nimi ilman erikoismerkkejä",
    "menus.Pré-aquecimento:": "Esilämmitys:",
    "menus.Grupo criado com sucesso!": "Ryhmä luotu onnistuneesti!",
    "menus.SELECIONE UMA IMAGEM": "VALITSE KUVA",
    "menus.SELECIONAR": "VALITSE",
    "menus.Selecionar do dispositivo": "Valitse laitteelta",
    "menus.Selecionar do banco de imagens": "Valitse kuvapankista",
    "menus.Formato .JPG ou .PNG": "Muoto .JPG tai .PNG",
    "menus.Procurar imagem": "Etsi kuva",
    "menus.Pertence ao menu": "Kuuluu valikkoon",
    "menus.Alterar imagem": "Vaihda kuva",
    "menus.Remover imagem": "Poista kuva",
    "menus.EDITAR GRUPO": "MUOKKAA RYHMÄÄ",
    "menus.Nome:": "Nimi:",
    "menus.CRIAR RECEITA": "LUO RESEPTI",
    "menus.SALVAR DO COOKBOOK": "TALLENNA COOKBOOKISTA",
    "menus.Procurar receita do grupo": "Etsi ryhmän reseptiä",
    "menus.Ingrediente principal": "Pääainesosa",
    "menus.Limpar filtros": "Tyhjennä suodattimet",
    "menus.Filtrar": "Suodata",
    "menus.Mover receitas": "Siirrä reseptejä",
    "menus.Excluir receitas": "Poista reseptejä",
    "menus.Editar grupo": "Muokkaa ryhmää",
    "menus.Excluir grupo": "Poista ryhmä",
    "menus.aqui": "tästä",
    "menus.Se o código possuir apenas números e o fundo da tela for verde, pertence à 1ª A, se possuir apenas números e o fundo da tela for preta, pertence à 1ª B e, se começar com as letras L, F ou S, sua placa pertence à 2ª geração/Linux.":
    "Jos koodi sisältää vain numeroita ja näytön tausta on vihreä, se kuuluu 1. sukupolveen A. Jos koodi sisältää vain numeroita ja tausta on musta, se kuuluu 1. sukupolveen B. Jos koodi alkaa kirjaimilla L, F tai S, kortti kuuluu 2. sukupolveen/Linuxiin.",
    "menus.1ª A - Fundo verde": "1. A - Vihreä tausta",
    "menus.1ª B - Fundo preto": "1. B - Musta tausta",
    "menus.2ª - Linux": "2. - Linux",
    "menus.Tivemos um problema. Tente novamente mais tarde.":
    "Tapahtui virhe. Yritä myöhemmin uudelleen.",
    "menus.Grupo editado com sucesso!": "Ryhmää muokattu onnistuneesti!",
    "menus.AINDA NÃO HÁ GRUPOS AQUI :(": "TÄÄLLÄ EI OLE VIELÄ RYHMIÄ :(",
    "menus.description.AINDA NÃO HÁ GRUPOS AQUI :(": "Napsauta oikeassa yläkulmassa olevaa painiketta ja lisää ryhmiä.",
    "menus.NENHUM MENU NA LIXEIRA": "ROSKAKORISSA EI OLE VALIKOITA",
    "menus.AINDA NÃO HÁ MENUS AQUI :(": "TÄÄLLÄ EI OLE VIELÄ VALIKOITA :(",
    "menus.description.AINDA NÃO HÁ MENUS AQUI :(": "Napsauta jotakin oikeassa yläkulmassa olevista painikkeista ja lisää valikoita.",
    "menus.Adicionar imagem": "Lisää kuva",
    "menus.Nome da receita": "Reseptin nimi",
    "menus.Detalhes da receita": "Reseptin tiedot",
    "menus.Programação da receita": "Reseptin ohjelmointi",
    "menus.Nomeie sua receita": "Anna reseptillesi nimi",
    "menus.Preencha o nome da receita sem caracteres especiais": "Anna reseptin nimi ilman erikoismerkkejä",
    "menus.Tipo de prato": "Ruokalaji",
    "menus.SALVAR RECEITAS DO COOKBOOK": "TALLENNA RESEPTIT COOKBOOKISTA",
    "menus.Selecione as receitas que deseja salvar no grupo de seu menu:":
    "Valitse reseptit, jotka haluat tallentaa valikkosi ryhmään:",
    "menus.Procurar receita": "Etsi reseptiä",
    "menus.deleteGroupSuccess":
    "{count, plural, one {Ryhmä poistettu onnistuneesti!} other {Ryhmät poistettu onnistuneesti!}}",
    "menus.deleteGroupError":
    "{count, plural, one {Ryhmää ei voitu poistaa.} other {Ryhmiä ei voitu poistaa.}}",
    "menus.EXCLUIR GRUPO": "POISTA RYHMÄ",
    "menus.confirmDeleteGroupMessage":
    "{count, plural, one {Haluatko poistaa ryhmän pysyvästi?} other {Haluatko poistaa ryhmät pysyvästi?}}",
    "menus.AINDA NÃO HÁ RECEITAS AQUI :(": "TÄÄLLÄ EI OLE VIELÄ RESEPTEJÄ :(",
    "menus.description.AINDA NÃO HÁ RECEITAS AQUI :(": "Napsauta jotakin oikeassa yläkulmassa olevista painikkeista ja lisää reseptejä.",
    "menus.Temp. de entrada": "Tulolämpötila",
    "menus.Temp. de pré-aquec": "Esilämmityslämpötila",
    "menus.Ingredientes para montagem": "Kokoamiseen tarvittavat ainekset",
    "menus.Instruções operacionais": "Käyttöohjeet",
    "menus.Passo": "Vaihe",
    "menus.Temp": "Lämpö ",
    "menus.Temp.": "Lämp. ",
    "menus.Tempo": "Aika",
    "menus.Velocidade do ar": "Ilman nopeus",
    "menus.Micro-ondas": "Mikroaallot",
    "menus.Resistência inferior": "Alavastus",
    "menus.Informações": "Tiedot",
    "menus.Digite as informações do passo": "Anna vaiheen tiedot",
    "menus.desativar": "poista käytöstä",
    "menus.Ingredientes": "Ainekset",
    "menus.Temperatura de entrada": "Tulolämpötila",
    "menus.Equipamentos compatíveis": "Yhteensopivat laitteet",
    "menus.Tempo total": "Kokonaisaika",
    "menus.SALVAR NO COOKBOOK": "TALLENNA COOKBOOKIIN",
    "menus.ver localização": "näytä sijainti",
    "menus.SELECIONE RECEITAS PARA EXCLUIR": "VALITSE POISTETTAVAT RESEPTIT",
    "menus.Você deseja excluir as receitas selecionadas definitivamente?":
    "Haluatko poistaa valitut reseptit pysyvästi?",
    "menus.Receitas deletadas com sucesso!": "Reseptit poistettu onnistuneesti!",
    "menus.Informe aqui os ingredientes para montagem":
    "Anna tähän kokoamiseen tarvittavat ainekset",
    "menus.Informe aqui as instruções operacionais":
    "Anna tähän käyttöohjeet",
    "menus.Adicionar passo": "Lisää vaihe",
    "menus.Receita criada com sucesso!": "Resepti luotu onnistuneesti!",
    "menus.Ideal para:": "Sopii erityisesti: ",
    "menus.editar detalhes": "muokkaa tietoja",
    "menus.excluir": "poista",
    "menus.editar": "muokkaa",
    "menus.Receita editada com sucesso!": "Reseptiä muokattu onnistuneesti!",
    "menus.Passo deletado com sucesso!": "Vaihe poistettu onnistuneesti!",
    "menus.Não foi possivel deletar o passo":
    "Vaihetta ei voitu poistaa",
    "menus.EXCLUIR PASSO": "POISTA VAIHE",
    "menus.Você deseja excluir este passo?": "Haluatko poistaa tämän vaiheen?",
    "menus.Esta ação não poderá ser desfeita. Caso prefira, é possível apenas desativá-lo, mantendo assim sua configuração.":
    "Tätä toimintoa ei voi kumota. Voit halutessasi vain poistaa vaiheen käytöstä säilyttäen sen asetukset.",
    "menus.Peso": "Paino",
    "menus.Origem da receita": "Reseptin alkuperä",
    "menus.Pré-aquecimento": "Esilämmitys",
    "menus.Plataforma": "Alusta",
    "menus.Receita salva com sucesso!": "Resepti tallennettu onnistuneesti!",
    "menus.Exportar receitas": "Vie reseptit",
    "menus.expandir": "laajenna",
    "menus.Temperatura": "Lämpötila",
    "menus.Vapor combinado": "Yhdistelmähöyry",
    "menus.Ar quente": "Kuuma ilma",
    "menus.Sonda": "Paistomittari",
    "menus.Tempo (min)": "Aika (min)",
    "menus.Umidade (%)": "Kosteus (%)",
    "menus.Injeção de vapor": "Höyryn syöttö",
    "menus.Dumper aberto": "Dumper avoinna",
    "menus.Informe o peso": "Anna paino",
    "menus.Informe a temperatura de entrada":
    "Anna tulolämpötila",
    "menus.Informe os ingredientes para montagem":
    "Anna kokoamiseen tarvittavat ainekset",
    "menus.Informe as instruções operacionais":
    "Anna käyttöohjeet",
    "menus.Injeção de vapor (seg)": "Höyryn syöttö (s)",
    "menus.Aquecer mais": "Lämmitä enemmän",
    "menus.Dourar mais": "Ruskista enemmän",
    "menus.Aquecer e dourar mais": "Lämmitä ja ruskista enemmän",
    "menus.Favoritar receita": "Lisää resepti suosikkeihin",
    "menus.Informe o tempo para aquecer mais":
    "Anna lisälämmitysajan pituus",
    "menus.Informe o tempo para dourar mais":
    "Anna lisäruskistusajan pituus",
    "menus.Informe o tempo para aquecer e dourar mais":
    "Anna lisälämmitys- ja ruskistusajan pituus",
    "menus.Apenas favoritos": "Vain suosikit",
    "menus.Forno combinado": "Yhdistelmäuuni",
    "menus.Cocção múltipla": "Monikypsennys",
    "menus.Receitas Technicook": "Technicook-reseptit",
    "menus.Editar grupos": "Muokkaa ryhmiä",
    "menus.Informe a data": "Anna päivämäärä",
    "menus.Informe a hora": "Anna kellonaika",
    "menus.até 300": "enintään 300",
    "menus.Vapor": "Höyry",
    "menus.Turbina": "Tuuletin",
    "menus.Criar grupo": "Luo ryhmä",
    "menus.MOVER": "SIIRRÄ",
    "menus.Configurações de data e hora:": "Päivämäärä- ja aika-asetukset:",
    "menus.Configurações de acessos:": "Käyttöoikeusasetukset:",
    "menus.Modo manual:": "Manuaalinen tila:",
    "menus.Favoritos:": "Suosikit:",
    "menus.Aquecer/dourar:": "Lämmitä/ruskista:",
    "menus.Repetir receita:": "Toista resepti:",
    "menus.Configurações gerais do menu:": "Valikon yleiset asetukset:",
    "menus.SELECIONE RECEITAS PARA MOVER": "VALITSE SIIRRETTÄVÄT RESEPTIT",
    "menus.AVANÇAR": "JATKA",
    "menus.Selecione ou crie um grupo no mesmo menu para mover as receitas selecionadas ou as mova para outro menu. Note que apenas os menus/grupos compatíveis com as predefinições das receitas serão exibidos.": "Valitse tai luo ryhmä samaan valikkoon siirtääksesi valitut reseptit tai siirrä ne toiseen valikkoon. Huomaa, että vain reseptien oletusasetusten kanssa yhteensopivat valikot/ryhmät näytetään.",
    "menus.Mover receitas para o mesmo menu": "Siirrä reseptit samaan valikkoon",
    "menus.Mover receitas para outro menu": "Siirrä reseptit toiseen valikkoon",
    "menus.Selecionar grupo": "Valitse ryhmä",
    "menus.Nenhuma receita foi selecionada": "Yhtään reseptiä ei ole valittu",
    "menus.Passo editado com sucesso!": "Vaihetta muokattu onnistuneesti!",
    "menus.Menu atualizado": "Valikko päivitetty",
    "menus.até 260": "enintään 260",
    "menus.Umidade na câmara": "Kammion kosteus",
    "menus.Passos": "Vaiheet",
    "menus.ativar": "ota käyttöön",
    "menus.Informe a temperatura de pré-aquec": "Anna esilämmityslämpötila",
    "menus.Movas as receitas selecionadas para outro menu. Note que apenas os menus compatíveis com as predefinições das receitas serão exibidos.":
    "Siirrä valitut reseptit toiseen valikkoon. Huomaa, että vain reseptien oletusasetusten kanssa yhteensopivat valikot näytetään.",
    "menus.Sonda (°C)": "Paistomittari (°C)",
    "menus.Turbo Grill": "Turbo Grill",
    "menus.Pré-aquecimento padrão, conforme passo 1": "Oletusesilämmitys vaiheen 1 mukaisesti",
    "menus.salvar": "tallenna",
    "menus.até": "enintään",
    "menus.Verificação de receita": "Reseptin tarkistus",
    "menus.Auto import": "Automaattinen tuonti",
    "menus.Atualização forçada": "Pakotettu päivitys",
    "menus.Lista de receitas exportada com sucesso!": "Reseptiluettelo viety onnistuneesti!",
    "menus.Receita movida com sucesso!": "Resepti siirretty onnistuneesti!",
    "menus.Receitas movidas com sucesso!": "Reseptit siirretty onnistuneesti!",
    "menus.+ Menu": "+ Valikko",
    "menus.+ Receita": "+ Resepti",
    "menus.Selecione o modelo/versão do equipamento": "Valitse laitteen malli/versio",
    "menus.Escolha um idioma compatível com o equipamento": "Valitse laitteen kanssa yhteensopiva kieli",
    "menus.MENU IMPORTADO COM SUCESSO!": "VALIKKO TUOTU ONNISTUNEESTI!",
    "menus.Dourar": "Ruskista",
    "menus.Não atribuir a menu": "Älä liitä valikkoon",
    "menus.Todos": "Kaikki",
    "menus.Meus menus": "Omat valikot",
    "menus.Para salvar uma receita, preencha todos os campos": "Täytä kaikki kentät tallentaaksesi reseptin",
    "menus.Selecione os grupos de equipamentos para os quais deseja exportar o menu.": "Valitse laitoryhmät, joihin haluat viedä valikon.",
    "menus.Formato inválido. São permitidos apenas os formatos .jpeg e .png": "Virheellinen tiedostomuoto. Vain .jpeg- ja .png-muodot ovat sallittuja",
    "menus.Reordenar grupos": "Järjestä ryhmät uudelleen",
    "menus.O que deseja fazer?": "Mitä haluat tehdä?",
    "menus.Reordenar receitas": "Järjestä reseptit uudelleen",
    "menus.ITENS REORDENADOS COM SUCESSO! PARA APLICAR AS ALTERAÇÕES NO FORNO, EXPORTE O MENU.": "KOHTEET JÄRJESTETTY UUDELLEEN ONNISTUNEESTI! OTA MUUTOKSET KÄYTTÖÖN UUNISSA VIEMÄLLÄ VALIKKO.",
    "menus.ARRASTE OS ITENS PARA O LOCAL DESEJADO": "VEDÄ KOHTEET HALUAMAASI SIJAINTIIN",
    "menus.Dumper": "Dumper",
    "menus.Aberto": "Avoin",
    "menus.Fechado": "Suljettu",
    "menus.Intermitente": "Jaksoittainen",
    "menus.Se o seu menu incluir itens sensíveis à uniformidade, recomendamos definir o Tempo de Estabilização entre 3:00 e 5:00 minutos. Caso contrário, você pode deixá-lo em 5 segundos.": "Jos valikkosi sisältää tuotteita, jotka ovat herkkiä tasaisuudelle, suosittelemme asettamaan vakautusajan välille 3:00–5:00 minuuttia. Muussa tapauksessa voit jättää sen 5 sekuntiin.",
    "menus.Selecione o menu que deseja exportar:": "Valitse valikko, jonka haluat viedä:",
    "menus.Temperatura de pré-aquecimento": "Esilämmityslämpötila",
    "menus.Temperatura de lastro": "Paistokiven lämpötila",
    "menus.Temperatura de teto": "Yläosan lämpötila",
    "menus.Volume de injeção de vapor (ml)": "Höyryn syöttömäärä (ml)",
    "menus.Parada de turbina": "Tuulettimen pysäytys",
    "menus.Alta": "Korkea",
    "menus.Média": "Keskitaso",
    "menus.Baixa": "Matala",
    "menus.a": "–",
    "menus.Valor da injeção": "Syötön arvo",
    "menus.Volume: até 999ml": "Tilavuus: enintään 999 ml",
    "menus.Tempo: até 15 segundos": "Aika: enintään 15 sekuntia",
    "menus.Tempo de injeção de vapor (seg)": "Höyryn syöttöaika (s)",
    "menus.Atenção!": "Huomio!",
    "menus.Verifique as receitas do menu e ajuste os valores da Injeção de Vapor após alterar sua unidade de medida.": "Tarkista valikon reseptit ja säädä höyrynsyötön arvot mittayksikön muuttamisen jälkeen.",
    "menus.Certifique-se de que a unidade de temperatura (°C ou °F) definida no equipamento seja a mesma que foi selecionada na criação do menu:": "Varmista, että laitteeseen asetettu lämpötilayksikkö (°C tai °F) on sama kuin valikkoa luotaessa valittu yksikkö:",
    "menus.Injeção desativada": "Syöttö poistettu käytöstä",
    "menus.Selecione a unidade de temperatura que está definida no equipamento:": "Valitse laitteeseen asetettu lämpötilayksikkö:",
    "menus.Clique para atualizar": "Päivitä napsauttamalla",
    "menus.A função Atualização Forçada envia automaticamente o menu para os equipamentos selecionados, e que possuam versão compatível com este tipo de atualização, na próxima vez em que forem ligados. Os fornos que não estiverem atualizados ainda precisarão realizar o aceite manual.": "Pakotettu päivitys -toiminto lähettää valikon automaattisesti valituille laitteille, jotka tukevat tätä päivitystapaa, seuraavan käynnistyksen yhteydessä. Uunit, joita ei ole vielä päivitetty, edellyttävät edelleen manuaalista hyväksyntää.",
    "menus.As opções selecionadas estarão disponíveis nos equipamentos que receberem este menu, podendo ser utilizadas pelo operador. É possível alterar estas configurações posteriormente no próprio forno ou pela plataforma.": "Valitut vaihtoehdot ovat käytettävissä laitteissa, jotka vastaanottavat tämän valikon, ja käyttäjä voi hyödyntää niitä. Näitä asetuksia voidaan myöhemmin muuttaa joko uunissa tai alustalla.",
    "menus.Não foi possivel deletar as receitas": "Reseptien poistaminen ei onnistunut",
    "menus.PRÉ": "ESI",
    "menus.Speed Ovens": "Speed Ovens",
    "menus.Fornos Combinados": "Yhdistelmäuunit",
    "menus.Fornos de Panificação": "Leivontauunit",
    "menus.Após a criação, o tipo do menu não pode ser alterado. Ele só pode ser definido no momento da criação.": "Valikon tyyppiä ei voi muuttaa luomisen jälkeen. Se voidaan määrittää vain luontivaiheessa.",
    "menus.Pré-aquecimento do grupo": "Ryhmän esilämmitys",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, transferindo a pasta PRATICA para o equipamento.": "Huomio: ennen kuin siirrät valikon USB-muistilta laitteeseen, pura tiedosto ja siirrä PRATICA-kansio laitteeseen.",
    "menus.Tamanho máximo": "Enimmäiskoko",
    "menus.Possibilita que o operador do forno crie parâmetros e os execute em seguida.": "Mahdollistaa uunin käyttäjän luoda parametreja ja käyttää niitä välittömästi.",
    "menus.Acesso também à execução das receitas favoritas.": "Mahdollistaa myös suosikkireseptien valmistuksen.",
    "menus.Possibilita que o operador adicione mais tempo para aquecer/dourar a refeição depois de sua execução.": "Mahdollistaa käyttäjän lisätä aikaa ruoan lämmittämiseen/ruskistamiseen valmistuksen jälkeen.",
    "menus.Possibilita a repetição da receita assim que sua execução é finalizada.": "Mahdollistaa reseptin toistamisen heti valmistuksen päätyttyä.",
    "menus.Acesso exclusivo às receitas favoritas.": "Pääsy vain suosikkiresepteihin.",
    "menus.Habilita o lembrete para o operador conferir se o alimento já está dentro do forno.": "Ottaa käyttöön muistutuksen, jotta käyttäjä tarkistaa, että ruoka on uunin sisällä.",
    "menus.O forno importa automaticamente, ao ligar, um menu que esteja salvo em pen drive e nele inserido.": "Uuni tuo käynnistyksen yhteydessä automaattisesti USB-muistille tallennetun ja siihen liitetyn valikon.",
    "menus.Possibilita a cocção de diversos alimentos simultaneamente, um em cada GN.": "Mahdollistaa useiden ruokien samanaikaisen kypsennyksen, yhden kutakin GN-astiaa kohden.",
    "menus.Permite a execução de receitas pré programadas, vindas de fábrica.": "Mahdollistaa tehtaalla esiohjelmoitujen reseptien valmistuksen.",
    "menus.Permite acesso à função turbo grill, que atinge até 300°C.": "Mahdollistaa Turbo Grill -toiminnon käytön, joka saavuttaa jopa 300 °C:n lämpötilan.",
    "menus.Possibilita que o operador adicione mais tempo para dourar a refeição depois de sua execução.": "Mahdollistaa käyttäjän lisätä aikaa ruoan ruskistamiseen valmistuksen jälkeen.",
    "menus.Permite que o operador edite grupos de receitas diretamente da tela inicial.": "Mahdollistaa reseptiryhmien muokkaamisen suoraan aloitusnäytöltä.",
    "menus.Copiar grupos": "Kopioi ryhmät",
    "menus.Excluir grupos": "Poista ryhmät",
    "menus.Copiar": "Kopioi",
    "menus.Selecione grupos para copiar": "Valitse kopioitavat ryhmät",
    "menus.Selecione o destino dos grupos": "Valitse ryhmien kohde",
    "menus.Colar": "Liitä",
    "menus.Deseja cancelar a cópia e envio de grupos para os menus?": "Haluatko peruuttaa ryhmien kopioinnin ja lähettämisen valikoihin?",
    "menus.Grupos colados com sucesso": "{count, plural, one {Ryhmä liitetty onnistuneesti!} other {Ryhmät liitetty onnistuneesti!}}",
    "menus.Copiar receitas": "Kopioi reseptit",
    "menus.Selecione receitas para copiar": "Valitse kopioitavat reseptit",
    "menus.Selecione o destino das receitas": "Valitse reseptien kohde",
    "menus.Deseja cancelar a cópia e envio de receitas para os grupos?": "Haluatko peruuttaa reseptien kopioinnin ja lähettämisen ryhmiin?",
    "menus.Receitas coladas com sucesso": "{count, plural, one {Resepti liitetty onnistuneesti!} other {Reseptit liitetty onnistuneesti!}}",
    "menus.Converter para C-MAX EVO": "Muunna C-MAX EVO:lle",
    "menus.Uma cópia deste menu, adaptada para o C-MAX EVO, será criada. Recomendamos que revise cuidadosamente todos os parâmetros dos passos e atualize as receitas com novas imagens, se julgar necessário.": "Tästä valikosta luodaan C-MAX EVO:lle mukautettu kopio. Suosittelemme tarkistamaan huolellisesti kaikki vaiheiden parametrit ja päivittämään reseptien kuvat tarvittaessa.",
    "menus.Menu convertido com sucesso!": "Valikko muunnettu onnistuneesti!",
    "menus.Não foi possível converter o menu. Tente novamente mais tarde": "Valikon muuntaminen ei onnistunut. Yritä myöhemmin uudelleen.",
    "menus.O menu está sendo convertido... Aguarde!": "Valikkoa muunnetaan... Odota!",
    "menus.Menu incompatível com": "Valikko ei ole yhteensopiva kohteen kanssa",
    "menus.Selecione pelo menos um grupo": "Valitse vähintään yksi ryhmä",
    "menus.Selecione pelo menos um menu": "Valitse vähintään yksi valikko",
    "menus.Menu atual": "Nykyinen valikko",
    "menus.Copiando grupos": "{count, plural, one {Ryhmää kopioidaan... Odota!} other {Ryhmiä kopioidaan... Odota!}}",
    "menus.Erro ao copiar grupos": "{count, plural, one {Ryhmän kopiointi ei onnistunut. Yritä myöhemmin uudelleen!} other {Ryhmien kopiointi ei onnistunut. Yritä myöhemmin uudelleen!}}",
    "menus.Procurar pelo nome do menu": "Hae valikon nimellä",
    "menus.Escolha um grupo de destino para cada menu selecionado": "Valitse kohderyhmä jokaiselle valitulle valikolle!",
    "menus.Copiando receitas": "{count, plural, one {Reseptiä kopioidaan... Odota!} other {Reseptejä kopioidaan... Odota!}}",
    "menus.Erro ao copiar receitas": "{count, plural, one {Reseptin kopiointi ei onnistunut. Yritä myöhemmin uudelleen!} other {Reseptien kopiointi ei onnistunut. Yritä myöhemmin uudelleen!}}",
    "menus.SELECIONE GRUPOS PARA EXCLUIR": "VALITSE POISTETTAVAT RYHMÄT",
    "menus.Padeiro noturno": "Yöleipuri",
    "menus.Permite programar o início (pré-aquecimento) de uma receita específica ou informada manualmente (Modo Manual), sem a necessidade de presença de um operador no local.": "Mahdollistaa tietyn tai manuaalisesti määritetyn reseptin (Manuaalinen tila) aloituksen (esilämmityksen) ajastamisen ilman käyttäjän läsnäoloa.",
    "menus.Vaporizador": "Höyrystin",
    "menus.Editar receitas": "Muokkaa reseptejä",
    "menus.Permite que o operador edite receitas diretamente da tela inicial.": "Mahdollistaa reseptien muokkaamisen suoraan aloitusnäytöltä.",
    "menus.Preencha o nome da receita": "Anna reseptin nimi",
    "menus.Tempo nível": "Aikataso",
    "menus.Fermentadora": "Nostatuskaappi",
    "menus.0 ou 5 a 59s": "0 tai 5 a 59 s",
    "menus.Selecione uma imagem" : "Valitse kuva",
    "menus.*Para criar receitas para fornos sem conectividade, crie um menu e então as receitas.": "*Jos haluat luoda reseptejä uuneille ilman verkkoyhteyttä, luo ensin valikko ja sen jälkeen reseptit.",
    "menus.CONVERTER": "MUUNNA",
    "menus.Converter para FIT": "Muunna FIT-mallille",
    "menus.Converter para outro FIT": "Muunna toiselle FIT-mallille",
    "menus.Selecione pelo menos um modelo FIT": "Valitse vähintään yksi FIT-malli",
    "menus.O menu está sendo convertido para FIT... Aguarde!": "Valikkoa muunnetaan FIT-mallille... Odota!",
    "menus.{count} menu(s) convertido(s) com sucesso para FIT!": "{count} valikko(a) muunnettu onnistuneesti FIT-mallille!",
    "menus.Alguns menus foram convertidos, mas houve falha em: {models}": "Osa valikoista muunnettiin, mutta seuraavien mallien kohdalla tapahtui virhe: {models}",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos.": "Tästä valikosta luodaan kopio jokaiselle valitulle FIT-mallille säilyttäen asetukset, ryhmät, reseptit ja vaiheet.",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos. No entanto, como cada forno possui dimensões e características específicas, recomendamos revisar e ajustar os parâmetros para garantir o melhor desempenho e resultado em cada equipamento. Selecione o modelo da linha FIT para qual deseja converter o menu." : "Tästä valikosta luodaan kopio jokaiselle valitulle FIT-mallille säilyttäen asetukset, ryhmät, reseptit ja vaiheet. Koska jokaisella uunilla on omat mitat ja ominaisuudet, suosittelemme tarkistamaan ja säätämään parametrit parhaan suorituskyvyn ja lopputuloksen varmistamiseksi kussakin laitteessa. Valitse FIT-tuoteperheen malli, jolle haluat muuntaa valikon.",
    
    //COOKBOOK
    "cookbook.RECEITAS DISPONÍVEIS": "SAATAVILLA OLEVAT RESEPTIT",
    "cookbook.RECEITAS SALVAS": "TALLENNETUT RESEPTIT",
    "cookbook.ENVIAR PARA MENU": "LÄHETÄ VALIKKOON",
    "cookbook.SALVAR": "TALLENNA",
    "cookbook.salvar": "tallenna",
    "cookbook.Filtrar por": "Suodata",
    "cookbook.Procurar receita do cookbook": "Hae Cookbook-reseptiä",
    "cookbook.Equipamento": "Laite",
    "cookbook.Ingrediente principal": "Pääainesosa",
    "cookbook.Tipo de prato": "Ruokalaji",
    "cookbook.Região": "Alue",
    "cookbook.Pré-aquecimento": "Esilämmitys",
    "cookbook.Procurar receita": "Hae reseptiä",
    "cookbook.Menu": "Valikko",
    "cookbook.ENVIAR": "LÄHETÄ",
    "cookbook.Procurar nome do menu": "Hae valikon nimellä",
    "cookbook.Escolha um grupo deste menu": "Valitse ryhmä tästä valikosta",
    "cookbook.Selecionar grupo": "Valitse ryhmä",
    "cookbook.Tivemos um problema. Tente novamente mais tarde":
    "Tapahtui ongelma. Yritä myöhemmin uudelleen.",
    "cookbook.Receita adicionada com sucesso!": "Resepti lisätty onnistuneesti!",
    "cookbook.Não foi possível adicionar a receita. Tente novamente mais tarde":
    "Reseptin lisääminen ei onnistunut. Yritä myöhemmin uudelleen.",
    "cookbook.Selecione um menu e um grupo para enviar esta receita":
    "Valitse valikko ja ryhmä lähettääksesi tämän reseptin",
    "cookbook.A receita não foi adicionada ao menu pois não há grupos criados":
    "Reseptiä ei lisätty valikkoon, koska ryhmiä ei ole luotu.",
    "cookbook.Selecione o modelo do equipamento primeiro": "Valitse ensin laitteen malli",
    "cookbook.Grupo": "Ryhmä",
    "cookbook.Não foi possível salvar os passos da receita": "Reseptin vaiheiden tallentaminen ei onnistunut",
    "cookbook.Bovina": "Naudanliha",
    "cookbook.Frango": "Kana",
    "cookbook.Ovos": "Munat",
    "cookbook.Pães": "Leivät",
    "cookbook.Peixes": "Kala",
    "cookbook.Queijo": "Juusto",
    "cookbook.Suína": "Sianliha",
    "cookbook.Vegetais": "Vihannekset",
    "cookbook.Outros": "Muut",
    "cookbook.Entradas/aperitivos": "Alkupalat",
    "cookbook.Principais": "Pääruoat",
    "cookbook.Snacks": "Välipalat",
    "cookbook.Pizzas": "Pizzat",
    "cookbook.Massas": "Pastat",
    "cookbook.Acompanhamentos": "Lisukkeet",
    "cookbook.Sobremesas": "Jälkiruoat",
    "cookbook.Manhã": "Aamiainen",
    "cookbook.Padaria": "Leipomo",
    "cookbook.Todos": "Kaikki",
    "cookbook.Não atribuir origem": "Älä määritä alkuperää",
    "cookbook.Brasil": "Brasilia",
    "cookbook.Alemanha": "Saksa",
    "cookbook.França": "Ranska",
    "cookbook.Rússia": "Venäjä",
    "cookbook.China": "Kiina",
    "cookbook.Japão": "Japani",
    "cookbook.Itália": "Italia",
    "cookbook.Egito": "Egypti",
    "cookbook.Grécia": "Kreikka",
    "cookbook.Argentina": "Argentiina",
    "cookbook.África": "Afrikka",
    "cookbook.Estados Unidos": "Yhdysvallat",
    "cookbook.Coreia": "Korea",
    "cookbook.Turquia": "Turkki",
    "cookbook.Ideal para": "Sopii erityisesti",
    "cookbook.Polônia": "Puola",
    "cookbook.Sanduíches": "Voileivät",
    "cookbook.Nova Receita": "Uusi resepti",
    
    //EQUIPAMENTOS
    "equipment.equipamentos": "laitteet",
    "equipment.procurar equipamento": "Hae laitetta tai käyttäjää",
    "equipment.adicionar equipamento": "lisää laite",
    "equipment.atualizar equipamento": "päivitä laite",
    "equipment.+ equipamentos": "+ laitteet",
    "equipment.buscar equipamento": "Hae laite",
    "equipment.Desvincular": "Poista liitos",
    "equipment.Editar": "Muokkaa",
    "equipment.sem conteúdo": "TÄÄLLÄ EI OLE VIELÄ LAITTEITA :(",
    "equipment.description.sem conteúdo": "Napsauta oikeassa yläkulmassa olevaa Lisää laite -painiketta ja liitä uunisi.",
    "equipment.editar equipamento": "muokkaa laitetta",
    "equipment.equipamento editado com sucesso!": "Laite muokattu onnistuneesti!",
    "equipment.não foi possível editar o equipamento. Tente novamente mais tarde": "Laitteen muokkaaminen ei onnistunut. Yritä myöhemmin uudelleen.",
    "equipment.Menu exportado com sucesso!": "Valikko viety onnistuneesti!",
    "equipment.Não foi possível exportar o menu. Tente novamente mais tarde": "Valikon vienti ei onnistunut. Yritä myöhemmin uudelleen.",
    "equipment.Selecione pelo menos um equipamento para enviar o menu": "Valitse vähintään yksi laite, johon valikko lähetetään",
    "equipment.Informações do menu": "Valikon tiedot",
    "equipment.Procurar receita ou grupo": "Hae reseptiä tai ryhmää",
    "equipment.Grupo": "Ryhmä",
    "equipment.Grupos de equipamentos": "Laiteryhmät",
    "equipment.Receita": "Resepti",
    "equipment.Quantidade": "Määrä",
    "equipment.Receitas mais preparadas no equipamento durante o período": "Laitteella eniten valmistetut reseptit valitulla ajanjaksolla",
    "equipment.Informações de limpeza": "Puhdistustiedot",
    "equipment.Data da limpeza": "Puhdistuspäivä",
    "equipment.Hora da limpeza": "Puhdistusaika",
    "equipment.nome": "Nimi",
    "equipment.modelo": "Malli",
    "equipment.categoria": "Luokka",
    "equipment.loja": "Myymälä",
    "desvincular equipamento": "Poista laitteen liitos",
    "equipment.unlink.paragrafo 1":
    "Haluatko poistaa laitteen liitoksen IOK-alustasta?",
    "equipment.unlink.paragrafo 2":
    "Tämän jälkeen et voi enää hallita laitteen asetuksia ja valikkoa alustan kautta, ellet liitä laitetta uudelleen noudattamalla yhdistämisohjeita.",
    "equipamento desvinculado com sucesso!":
    "Laitteen liitos poistettu onnistuneesti!",
    "equipment.ocorreu um erro. Tente novamente mais tarde":
    "Tapahtui virhe. Yritä myöhemmin uudelleen.",
    "equipment.sim": "Kyllä",
    "equipment.não": "Ei",
    "equipment.Encerrar acesso remoto": "Lopeta etäkäyttö",
    "equipment.Horas sem limpeza": "Tunnit ilman puhdistusta",
    "equipment.Histórico de eventos": "Tapahtumahistoria",
    "equipment.Histórico de eventos do forno": "Uunin tapahtumahistoria",
    "equipment.Histórico de eventos da fermentadora": "Nostatuskaapin tapahtumahistoria",
    "equipment.Receitas executadas": "Valmistetut reseptit",
    "equipment.Hoje": "Tänään",
    "equipment.Tempo de porta aberta": "Oven aukioloaika",
    "equipment.Tempo médio aproximado": "Arvioitu keskimääräinen aika",
    "equipment.Filtrar eventos": "Suodata tapahtumat",
    "equipment.Evento": "Tapahtuma",
    "equipment.Data": "Päivämäärä",
    "equipment.ERRO SENSOR RI": "Virhe alavastuksen anturissa",
    "equipment.ERRO COM INV. DE FREQ.": "Virhe taajuusmuuttajassa",
    "equipment.ERRO MAGNETRON": "Magnetronivirhe",
    "equipment.ERRO SENSOR CAMARA": "Virhe kammion anturissa",
    "equipment.ERRO CAN": "CAN-virhe",
    "equipment.Erro INVERSOR DE FREQUENCIA": "Taajuusmuuttajan virhe",
    "equipment.ERRO DO MODELO DO EQUIPAMENTO": "Laitemallin virhe",
    "equipment.ERRO PAINEL": "Paneelivirhe",
    "equipment.ERRO INV.FREQ.STATUS": "Taajuusmuuttajan tilavirhe",
    "equipment.ERRO SENSOR BOARD": "Virhe piirilevyn anturissa",
    "equipment.ERRO ENERGY": "Energiavirhe",
    "equipment.ERRO I2C": "I2C-virhe",
    "equipment.EQUIPAMENTO LIGADO": "Laite käynnissä",
    "equipment.EQUIPAMENTO DESLIGADO": "Laite sammutettu",
    "equipment.Plataforma": "Alusta",
    "equipment.Forno": "Uuni",
    "equipment.Origem": "Alkuperä",
    "equipment.Locais": "Sijainnit",
    "equipment.não foi possível carregar as entidades": "Tietojen lataaminen ei onnistunut",
    "equipment.conceder acesso remoto a": "Myönnä etäkäyttöoikeus käyttäjälle",
    "equipment.atualizar software": "päivitä ohjelmisto",
    "equipment.suporte": "tuki",
    "equipment.PIN": "PIN",
    "equipment.nome do equipamento": "Laitteen nimi",
    "equipment.vinculado à loja": "Liitetty myymälään",
    "equipment.cadastrar loja": "Rekisteröi myymälä",
    "equipment.informe o PIN do forno": "Anna uunin PIN-koodi",
    "equipment.preencha o PIN do forno": "Täytä uunin PIN-koodi",
    "equipment.adicione um nome para facilitar seu reconhecimento":
    "Lisää nimi helpottamaan tunnistamista",
    "equipment.preencha o nome do equipamento":
    "Täytä laitteen nimi",
    "equipment.selecionar": "Valitse",
    "equipment.nome fantasia": "Toiminimi",
    "equipment.informe o nome fantasia": "Anna toiminimi",
    "equipment.preencha o nome fantasia": "Täytä toiminimi",
    "equipment.CNPJ": "CNPJ",
    "equipment.XX.XXX.XXX/0001.XX": "XX.XXX.XXX/0001.XX",
    "equipment.preencha o CNPJ": "Täytä CNPJ",
    "equipment.CEP": "Postinumero",
    "equipment.00000-000": "00000-000",
    "equipment.preencha o CEP": "Täytä postinumero",
    "equipment.cidade": "Kaupunki",
    "equipment.informe a cidade": "Anna kaupunki",
    "equipment.preencha a cidade": "Täytä kaupunki",
    "equipment.UF": "Osavaltio",
    "equipment.bairro": "Kaupunginosa",
    "equipment.informe o bairro": "Anna kaupunginosa",
    "equipment.endereço": "Osoite",
    "equipment.informe o seu endereço": "Anna osoitteesi",
    "equipment.preencha o seu endereço": "Täytä osoitteesi",
    "equipment.Nº": "Nro",
    "equipment.equipamento cadastrado com sucesso!":
    "Laite rekisteröity onnistuneesti!",
    "equipment.ocorreu um erro": "Tapahtui virhe",
    "equipment.preencha o modelo": "Täytä malli",
    "equipment.selecione uma categoria": "Valitse luokka",
    "equipment.selecione uma loja": "Valitse myymälä",
    "equipment.preencha o bairro": "Täytä kaupunginosa",
    "equipment.não foi possível cadastrar o equipamento. Tente novamente mais tarde":
    "Laitteen rekisteröinti ei onnistunut. Yritä myöhemmin uudelleen.",
    "equipment.loja cadastrada com sucesso": "Myymälä rekisteröity onnistuneesti",
    "equipment.não foi possível cadastrar a loja. Tente novamente mais tarde":
    "Myymälän rekisteröinti ei onnistunut. Yritä myöhemmin uudelleen.",
    "equipment.equipment": "laitteet",
    "equipment.search equipment": "hae laitetta",
    "equipment.add equipment": "lisää laite",
    "equipment.update equipment": "päivitä laite",
    "equipment.plus equipment": "+ laite",
    "equipment.Procurar equipamento": "Hae laitetta",
    "equipment.EQUIPAMENTOS": "LAITTEET",
    "equipment.Atualizar equipamento": "Päivitä laite",
    "equipment.Atualizar equipamentos": "Päivitä laitteet",
    "equipment.confirmar": "vahvista",
    "equipment.Selecione os modelos que deseja atualizar:": "Valitse mallit, jotka haluat päivittää:",
    "equipment.Como deseja realizar a atualização?": "Miten haluat suorittaa päivityksen?",
    "equipment.Enviar atualização pela plataforma (internet)": "Lähetä päivitys alustan kautta (internet)",
    "equipment.Salvar arquivo de atualização no dispositivo": "Tallenna päivitystiedosto laitteelle",
    "equipment.Linha Express": "Express-tuotelinja",
    "equipment.Escolha como deseja realizar a atualização": "Valitse, miten haluat suorittaa päivityksen",
    "equipment.Selecione ao menos um modelo de equipamento para atualizar": "Valitse vähintään yksi päivitettävä laitemalli",
    "equipment.Status: ": "Tila: ",
    "equipment.Número de série:": "Sarjanumero:",
    "equipment.Menu:": "Valikko:",
    "equipment.Status:": "Tila:",
    "equipment.Número de série": "Sarjanumero",
    "equipment.Menu": "Valikko",
    "equipment.Loja: ": "Myymälä: ",
    "equipment.End:": "Osoite: ",
    "equipment.Endereço:": "Osoite: ",
    "equipment.Cidade:": "Kaupunki: ",
    "equipment.CEP:": "Postinumero: ",
    "equipment.Atualização de software enviada com sucesso!": "Ohjelmistopäivitys lähetetty onnistuneesti!",
    "equipment.Não foi possível enviar a atualização de software. Tente novamente mais tarde": "Ohjelmistopäivityksen lähettäminen ei onnistunut. Yritä myöhemmin uudelleen.",
    "equipment.Download realizado com sucesso": "Lataus onnistui",
    "equipment.Não foi possível realizar o download. Tente novamente mais tarde": "Lataus ei onnistunut. Yritä myöhemmin uudelleen.",
    "equipment.Solicitação processada com erro. Tente novamente mais tarde": "Pyyntö käsiteltiin virheellisesti. Yritä myöhemmin uudelleen.",
    "equipment.Preencha o nome da versão": "Anna version nimi",
    "equipment.Informe aqui todas as alterações desta nova versão": "Kirjoita tähän kaikki tämän uuden version muutokset",
    "equipment.Nova versão de software atualizada com sucesso!": "Uusi ohjelmistoversio päivitetty onnistuneesti!",
    "equipment.Informe pelo menos uma mudança nesta versão": "Ilmoita vähintään yksi muutos tässä versiossa",
    "equipment.Falha ao transformar o arquivo em Blob": "Tiedoston muuntaminen Blob-muotoon epäonnistui",
    "equipment.Erro ao criar Blob a partir do arquivo": "Virhe luotaessa Blob-objektia tiedostosta",
    "equipment.Falha ao ler o arquivo": "Tiedoston lukeminen epäonnistui",
    "equipment.selecionar tipo": "valitse tyyppi",
    "equipment.selecione o tipo da versão": "valitse version tyyppi",
    "equipment.atualização": "PÄIVITYS",
    "equipment.Selecione abaixo o que deseja fazer:": "Valitse alta, mitä haluat tehdä:",
    "equipment.Atualizar meus equipamentos": "Päivitä laitteeni",
    "equipment.Enviar atualização para usuários selecionados": "Lähetä päivitys valituille käyttäjille",
    "equipment.ENVIAR": "LÄHETÄ",
    "equipment.ENVIAR ATUALIZAÇÃO": "LÄHETÄ PÄIVITYS",
    "equipment.Selecione os e-mails para os quais deseja enviar a atualização:": "Valitse sähköpostiosoitteet, joihin haluat lähettää päivityksen:",
    "equipment.A atualização disponibilizada no dia": "Päivänä julkaistu päivitys ",
    "equipment.referente ao equipamento": "laitteelle ",
    "equipment.contempla o seguinte:": "sisältää seuraavat muutokset:",
    "equipment.Selecionar arquivo para envio": "Valitse lähetettävä tiedosto",
    "equipment.Por favor, selecione um arquivo .tar": "Valitse .tar-tiedosto",
    "equipment.Selecione o modelo do equipamento:": "Valitse laitteen malli:",
    "equipment.Selecione uma opção": "Valitse vaihtoehto",
    "equipment.Nomeie a versão": "Anna versiolle nimi",
    "equipment.Clique sobre o arquivo que deseja baixar:": "Napsauta tiedostoa, jonka haluat ladata:",
    "equipment.Baixar atualização": "Lataa päivitys",
    "equipment.Versões": "Versiot",
    "equipment.e superiores": "ja uudemmat",
    "equipment.name": "nimi",
    "equipment.model": "malli",
    "equipment.category": "luokka",
    "equipment.store": "myymälä",
    "FIT Express/FIT ST": "FIT Express/FIT ST",
    "Copa/Single Mag/Rocket": "Copa/Single Mag/Rocket",
    "Forza STi": "Forza STi",
    "TSi": "TSi",
    "FIT Express": "FIT Express",
    "FIT ST": "FIT ST",
    "FIT Express, FIT ST": "FIT Express, FIT ST",
    "Copa Express, Rocket Express, Copa Single Mag": "Copa Express, Rocket Express, Copa Single Mag",
    "equipment.e": "ja",
    "equipment.Últimas versões de software:": "Viimeisimmät ohjelmistoversiot: ",
    "equipment.Você não possui nenhum equipamento desatualizado": "Sinulla ei ole vanhentuneita laitteita",
    "equipment.grupos": "ryhmät",
    "equipment.não foi possível carregar os grupos de equipamentos da companhia": "Yrityksen laite­ryhmien lataaminen ei onnistunut",
    "equipment.vinculado ao grupo": "Liitetty ryhmään",
    "equipment.selecione um grupo": "Valitse ryhmä",
    "equipment.cadastrar grupo": "Rekisteröi ryhmä",
    "equipment.Número de Série": "SN",
    "equipment.Versão": "Versio",
    "equipment.não foi possível cadastrar o equipamento. Selecione ou cadastre um grupo": "Laitteen rekisteröinti ei onnistunut. Valitse tai luo ryhmä",
    "equipment.CRIE GRUPOS DE EQUIPAMENTOS!": "LUO LAITERYHMIÄ!",
    "equipment.Para que os usuários vinculados à conta possam visualizar os equipamentos você precisa:": "Jotta tiliin liitetyt käyttäjät voivat nähdä laitteet, sinun tulee:",
    "equipment.1) Criar grupo(s);": "1) Luo ryhmä(t);",
    "equipment.2) Atribuir equipamento(s) ao grupo;": "2) Liitä laite(laitteet) ryhmään;",
    "equipment.3) Atribuir usuário(s) ao grupo.": "3) Liitä käyttäjä(t) ryhmään.",
    "equipment.Status software": "Ohjelmiston tila",
    "equipment.Status menu": "Valikon tila",
    "equipment.Pendente": "Odottaa",
    "equipment.Aceito": "Hyväksytty",
    "equipment.Recusado": "Hylätty",
    "equipment.Atualizar software": "Päivitä ohjelmisto",
    "equipment.Deseja enviar a atualização para o equipamento selecionado?": "Haluatko lähettää päivityksen valittuun laitteeseen?",
    "equipment.Companhia": "Yritys",
    "equipment.Exportar menu": "Vie valikko",
    "equipment.companhias": "yritykset",
    "equipment.Nome da companhia": "Yrityksen nimi",
    "equipment.Procurar equipamento, usuário ou companhia": "Etsi laitetta, käyttäjää tai yritystä",
    "equipment.Versão da power": "Power-version",
    "equipment.AINDA NÃO HÁ DADOS DE RECEITAS AQUI :(": "TÄÄLLÄ EI OLE VIELÄ RESEPTITIETOJA :(",
    "equipment.AINDA NÃO HÁ DADOS DE LIMPEZAS AQUI :(": "TÄÄLLÄ EI OLE VIELÄ PUHDISTUSTIETOJA :(",
    "equipment.AINDA NÃO HÁ DADOS DE EVENTOS AQUI :(": "TÄÄLLÄ EI OLE VIELÄ TAPAHTUMATIETOJA :(",
    "ID": "ID",
    "equipment.Hora": "Aika",
    "equipment.EVENTOS MAIS OCORRIDOS NO EQUIPAMENTO DURANTE O PERÍODO": "YLEISIMMÄT TAPAHTUMAT LAITTEESSA VALITULLA AJANJAKSOLLA",
    "equipment.hour": "h",
    "equipment.minutes": "min",
    "equipment.date format": "PP/KK/VVVV",
    "equipment.preparada": "valmistettu",
    "equipment.vezes": "kertaa",
    "equipment.vez": "kerta",
    "equipment.Ver": "Näytä",
    "equipment.Os dados são mantidos pela plataforma pelo tempo necessário para suporte, manutenção e evolução dos produtos.": "Alusta säilyttää tiedot niin kauan kuin se on tarpeen tuotteiden tuen, ylläpidon ja kehityksen kannalta.",
    "equipment.Ligado": "Päällä",
    "equipment.Desligado": "Pois päältä",
    "equipment.CAN ERROR": "CAN-virhe",
    "equipment.CAMERA SENSOR ERROR": "Kammioanturin virhe",
    "equipment.STEAM/RI SENSOR ERROR": "RI-anturin virhe",
    "equipment.PROBE 1 ERROR": "Anturi 1 -hälytys",
    "equipment.PROBE 2 ERROR": "Anturi 2 -hälytys",
    "equipment.PROBE 3 ERROR": "Anturi 3 -hälytys",
    "equipment.PROBE 4 ERROR": "Anturi 4 -hälytys",
    "equipment.PROBE 5 ERROR": "Anturi 5 -hälytys",
    "equipment.PROBE 6 ERROR": "Anturi 6 -hälytys",
    "equipment.GENERAL PROBE ERROR": "Yleinen anturivirhe",
    "equipment.WATER LACK ERROR": "Veden puutteen hälytys",
    "equipment.HIGH PANEL TEMPERATURE ERROR": "Paneelin korkean lämpötilan hälytys",
    "equipment.FREQUENCY INVERTER GENERAL ERROR": "Yleinen taajuusmuuttajan virhe",
    "equipment.FREQUENCY INVERTER COMMUNICATION ERROR": "Taajuusmuuttajan tiedonsiirtohälytys",
    "equipment.FREQUENCY INVERTER STATUS ERROR": "Taajuusmuuttajan tilahälytys",
    "equipment.CLEANING NOT COMPLETED ERROR": "Puhdistusta ei suoritettu loppuun -hälytys",
    "equipment.MAGNETRON ERROR": "Magnetronihälytys",
    "equipment.EQUIPMENT FAMILY/MODEL ERROR": "Laitemallin virhe",
    "equipment.BOARD TEMPERATURE SENSOR ERROR": "Piirikortin lämpötila-anturin hälytys",
    "equipment.ENERGY MODULE ERROR": "Energiamoduulin virhe",
    "equipment.POWER BOARD I2C BUS ERROR": "Power-kortin I2C-väylän virhe",
    "equipment.GAS SYSTEM ERROR": "Kaasujärjestelmän virhe",
    "equipment.VERY HIGH PANEL TEMPERATURE ERROR": "Paneelin erittäin korkean lämpötilan virhe",
    "equipment.POWER ON": "Päällä",
    "equipment.POWER OFF": "Pois päältä",
    "equipment.DOOR OPENED": "Ovi avattu",
    "equipment.DOOR CLOSED": "Ovi suljettu",
    "equipment.CLEANING CANCELED ERROR": "Käyttäjä keskeytti puhdistuksen",
    "equipment.PIN não encontrado. Por favor, verifique e tente novamente": "PIN-koodia ei löytynyt. Tarkista tiedot ja yritä uudelleen.",
    "equipment.Ultracongeladores": "Pikajäähdyttimet",
    "equipment.PIN já vinculado a outra conta": "PIN-koodi on jo liitetty toiseen tiliin",
    "equipment.Equipamento já cadastrado nesta conta": "Laite on jo rekisteröity tälle tilille",
    "equipment.Não foi possível validar o PIN. Tente novamente": "PIN-koodia ei voitu vahvistaa. Yritä uudelleen",
    "equipment.Modelo definido pelo equipamento": "Laitteen määrittämä",
    "equipment.Número de série offline inválido": "Syötä seitsemän numeroa ilman välilyöntejä tai alkunollaa",
    "equipment.Número de série já cadastrado": "Sarjanumero on jo rekisteröity",
    "equipment.Online": "Päällä",
    "equipment.Offline": "Pois päältä",
    "equipment.Exibir apenas eventos": "Näytä vain tapahtumat",
    "equipment.Endereço": "Osoite",
    "equipment.EQUIPMENT CONNECTED TO THE PLATFORM": "Laite yhdistetty alustaan",
    "equipment.EQUIPMENT DISCONNECTED FROM THE PLATFORM": "Laite irrotettu alustasta",
    "equipment.MENU RECEIVED FROM THE PLATFORM": "Käyttäjä hyväksyi alustan valikon",
    "equipment.MENU REJECTED BY THE USER": "Käyttäjä hylkäsi alustan valikon",
    "equipment.CONNECTED TO THE INTERNET": "Yhdistetty internetiin",
    "equipment.DISCONNECTED FROM THE INTERNET": "Yhteys internetiin katkaistu",
    "equipment.Infelizmente, não há versões compatíveis com este equipamento que realizem o envio de dados.": "Valitettavasti tälle laitteelle ei ole yhteensopivia ohjelmistoversioita, jotka tukevat tiedonsiirtoa.",
    "equipment.O equipamento": "Laite",
    "equipment.deve ser atualizado para a versão mais recente de software para que passe a enviar os dados para a plataforma": "on päivitettävä uusimpaan ohjelmistoversioon, jotta se voi lähettää tietoja alustalle",
    "equipment.Versão do seu equipamento": "Laitteesi versio",
    "equipment.Versão disponível": "Saatavilla oleva versio",
    "equipment.Selecione abaixo como deseja enviar a atualização para seu equipamento": "Valitse alla, miten haluat lähettää päivityksen laitteellesi",
    "equipment.Salvar no dispositivo": "Tallenna laitteelle",
    "equipment.Enviar pela internet": "Lähetä internetin kautta",
    "equipment.Cliente": "Asiakas",
    "equipment.NÚMERO DE SÉRIE NÃO ENCONTRADO": "SARJANUMEROA EI LÖYTYNYT",
    "equipment.BUSCAR": "HAE",
    "equipment.ACESSADOS RECENTEMENTE": "ÄSKETTÄIN KÄYTETYT",
    "equipment.SEM BUSCAS RECENTES": "EI VIIMEAIKAISIA HAKUJA",
    "equipment.description.SEM BUSCAS RECENTES": "Etsi laitteita sarjanumeron avulla.",
    "equipment.Procurar equipamento pelo número de série": "Etsi laitetta sarjanumerolla",
    "equipment.AIR FILTER CLEANING COMPLETED": "Ilmansuodattimen puhdistus valmis",
    "equipment.AIR FILTER CLEANING REJECTED": "Ilmansuodattimen puhdistus hylätty",
    "equipment.CATALYTIC FILTER CLEANING COMPLETED": "Katalyyttisuodattimen puhdistus valmis",
    "equipment.CATALYTIC FILTER CLEANING REJECTED": "Katalyyttisuodattimen puhdistus hylätty",
    "equipment.Endereço (rua, avenida, rodovia)": "Osoite (katu, tie, valtatie)",
    "equipment.Nº/Km": "Nro/Km",
    "equipment.ID do equipamento": "Laitteen tunnus",
    "equipment.Todo equipamento deve ser vinculado a um grupo. Selecione um grupo da lista ou cadastre um novo clicando em + Cadastrar grupo.": "Jokainen laite on liitettävä ryhmään. Valitse ryhmä luettelosta tai luo uusi napsauttamalla + Luo ryhmä.",
    "equipment.Nomeie seu forno": "Anna uunillesi nimi",
    "equipment.Para visualizar o PIN, acesse nas configurações do equipamento a Plataforma Virtual IOK.": "Voit tarkastella PIN-koodia siirtymällä laitteen asetuksissa IOK-virtuaalialustaan.",
    "equipment.Vinculação IOK": "IOK-liitäntä",
   "equipment.Preparações": "Valmistukset",
    "equipment.recipeTable.recipe": "Resepti",
    "equipment.recipeTable.origin": "Alk.",
    "equipment.recipeTable.executions": "Suor.",
    "equipment.recipeTable.lastExecution": "Viimeisin suoritus",
    "equipment.Última preparação": "Viimeisin valmistus",
    "equipment.localização": "sijainti",
    "equipment.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "SIJAINTEJA EI OLE VIELÄ LISÄTTY :(",
    "equipment.description.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "Napsauta oikeassa yläkulmassa olevaa painiketta lisätäksesi sijainnin.",
    "equipment.Procurar empresa ou local": "Etsi yritystä tai sijaintia",
    "equipment.Adicionar localização": "Lisää sijainti",
    "equipment.Adicionar": "Lisää",
    "equipment.espaço": "Tila",
    "equipment.local": "Sijainti",
    "equipment.EXCLUIR LOCALIZAÇÃO": "POISTA SIJAINTI",
    "equipment.Você deseja excluir esta localização?": "Haluatko poistaa tämän sijainnin?",
    "equipment.Ao fazer isso, os equipamentos atrelados à ela não exibirão nenhuma localização, sendo necessário informar um novo local para eles.": "Tämän jälkeen siihen liitetyt laitteet eivät enää näytä sijaintia, ja niille on määritettävä uusi sijainti.",
    "equipment.Localização deletada com sucesso!": "Sijainti poistettiin onnistuneesti!",
    "equipment.Erro ao deletar a localização. Tente novamente mais tarde": "Sijainnin poistaminen epäonnistui. Yritä myöhemmin uudelleen.",
    "equipment.Não foi possivel deletar a localização": "Sijainnin poistaminen ei onnistunut",
    "equipment.Localização adicionada com sucesso!": "Sijainti lisättiin onnistuneesti!",
    "equipment.Não foi possível adicionar a localização. Tente novamente mais tarde": "Sijainnin lisääminen epäonnistui. Yritä myöhemmin uudelleen.",
    "equipment.Nome do espaço": "Tilan nimi",
    "equipment.Informe o nome do espaço": "Anna tilan nimi",
    "equipment.Preencha o nome do espaço": "Täytä tilan nimi",
    "equipment.país": "Maa",
    "equipment.informe o país": "Anna maa",
    "equipment.preencha o país": "Täytä maa",
    "equipment.Localização editada com sucesso!": "Sijainti päivitettiin onnistuneesti!",
    "equipment.Não foi possível editar a localização. Tente novamente mais tarde": "Sijainnin muokkaaminen epäonnistui. Yritä myöhemmin uudelleen.",
    "equipment.Editar localização": "Muokkaa sijaintia",
    "equipment.Pico de preparações": "Valmistusten huippuaika",
    "equipment.informações da semana": "viikon tiedot",
    "equipment.horários de pico": "ruuhka-ajat",
    "equipment.horário de pico": "ruuhka-aika",
    "equipment.preparações do dia": "päivän valmistukset",
    "equipment.Horário": "Aika",
    "equipment.dia selecionado": "valittu päivä",
    "equipment.A limpeza adequada e diária do forno auxilia em seu funcionamento correto e impacta na garantia.": "Uunin asianmukainen päivittäinen puhdistus auttaa varmistamaan sen oikean toiminnan ja vaikuttaa takuuseen.",
    "equipment.Total de limpezas realizadas:": "Suoritettujen puhdistusten kokonaismäärä:",
    "equipment.Limpezas não concluídas:": "Kesken jääneet puhdistukset:",
    "equipment.Desde a vinculação do forno a IOK": "Siitä lähtien, kun uuni liitettiin IOK:hon",
    "equipment.Equipamento ligado há:": "Laite ollut päällä:",
    "equipment.Total de receitas preparadas:": "Valmistettujen reseptien kokonaismäärä:",
    "equipment.Receitas preparadas": "Valmistetut reseptit",
    "equipment.Aberturas de porta": "Oven avaukset",
    "equipment.Desde a última vez que o forno foi ligado": "Viimeisimmästä uunin käynnistyksestä lähtien",
    "equipment.Preparação": "Valmistus",
    "equipment.Nenhuma localização criada": "Sijainteja ei ole luotu",
    "equipment.Acesso remoto": "Etäkäyttö",
    "equipment.Informe o ID da empresa que poderá acessar remotamente seu forno. Use ; para separar IDs.": "Anna sen yrityksen tunnus, jolle haluat myöntää etäkäyttöoikeuden uuniisi. Erottele tunnukset puolipisteellä (;).",
    "equipment.O acesso remoto permite que as empresas selecionadas enviem menus e atualizações para seu equipamento.": "Etäkäyttö mahdollistaa valittujen yritysten lähettää valikoita ja päivityksiä laitteellesi.",
    "equipment.Concedo acesso remoto à Prática oficial.": "Myönnän etäkäyttöoikeuden viralliselle Práticalle.",
    "equipment.Deseja selecionar outros equipamentos vinculados à sua conta para conceder acesso remoto a eles?": "Haluatko valita muita tiliisi liitettyjä laitteita myöntääksesi niille etäkäyttöoikeuden?",
    "equipment.Selecione abaixo os equipamentos para os quais deseja conceder acesso remoto à": "Valitse alta laitteet, joille haluat myöntää etäkäyttöoikeuden:",
    "equipment.Acesso remoto concedido com sucesso!": "Etäkäyttöoikeus myönnetty onnistuneesti!",
    "equipment.Selecione pelo menos um equipamento": "Valitse vähintään yksi laite",
    "equipment.Não foi possível editar os equipamentos. Tente novamente mais tarde": "Laitteiden muokkaaminen ei onnistunut. Yritä myöhemmin uudelleen.",
    "equipment.Solicitar atendimento": "Pyydä huoltoa",
    "equipment.Relate um problema": "Ilmoita ongelmasta",
    "equipment.Descreva aqui o problema de seu equipamento": "Kuvaile tähän laitteesi ongelma",
    "equipment.Não foi possível enviar sua solicitação de atendimento. Tente mais tarde": "Huoltopyyntöäsi ei voitu lähettää. Yritä myöhemmin uudelleen.",
    "equipment.Solicitação técnica enviada com sucesso!": "Tekninen huoltopyyntö lähetettiin onnistuneesti!",
    "equipment.Enviar": "Lähetä",
    "equipment.Solicitação de atendimento": "Huoltopyyntö",
    "equipment.Informe o problema de seu equipamento": "Kuvaile laitteesi ongelma",
    "equipment.Informações do magnetron": "Magnetronin tiedot",
    "equipment.Vida útil aproximada": "Arvioitu käyttöikä",
    "equipment.MAGNETRON USAGE HOURS": "Magnetronin käyttötunnit",
    "equipment.Atendimento": "Huolto",
    "equipment.Eventos mais ocorridos no equipamento durante o período": "Laitteen yleisimmät tapahtumat valitulla ajanjaksolla",
    "equipment.EQUIPAMENTO SEM NÚMERO DE SÉRIE": "LAITTEELLA EI OLE SARJANUMEROA",
    "equipment.Filtros": "Suodattimet",
    "equipment.Filtrar": "Suodata",
    "equipment.Limpar filtros": "Tyhjennä suodattimet",
    "equipment.Procurar por modelo, versão ou país": "Etsi mallin, version tai maan perusteella",
    "equipment.Procurar equipamento, NS, modelo, versão ou país": "Etsi laitetta, SN:ää, mallia, versiota tai maata",
    "equipment.Os seguintes IDs não pertencem a uma companhia do tipo 'Distribuidor' e foram removidos": "Seuraavat tunnukset eivät kuulu 'Jakelija'-tyyppiseen yritykseen, ja ne on poistettu",
    "equipment.BAIXAR VERSÕES": "LATAA VERSIOT",
    "equipment.Compatível com todas as versões da IHM.": "Yhteensopiva kaikkien IHM-versioiden kanssa.",
    "equipment.Compatível apenas com a versão 2.0.0C da Power.": "Yhteensopiva vain Power-version 2.0.0C kanssa.",
    "equipment.Procurar evento": "Etsi tapahtumaa",
    "equipment.Forno conectado": "Uuni yhdistetty",
    "equipment.Limpeza de filtro de ar": "Ilmansuodattimen puhdistus",
    "equipment.Limpeza de filtro catalítico": "Katalyyttisuodattimen puhdistus",
    "equipment.Limpeza realizada": "Puhdistus suoritettu",
    "equipment.Limpeza recomendada": "Suositeltu puhdistus",
    "equipment.Forno ligado": "Uuni päällä",
    "equipment.Inversor de frequência": "Taajuusmuuttaja",
    "equipment.Temperatura de painel": "Paneelin lämpötila",
    "equipment.Sensor da câmara": "Kammioanturi",
    "equipment.Magnetron": "Magnetroni",
    "equipment.Power": "Power",
    "equipment.Informações de menu": "Valikon tiedot",
    "equipment.Limpeza": "Puhdistus",
    "equipment.O equipamento já está utilizando a versão mais recente do software.": "Laite käyttää jo uusinta ohjelmistoversiota.",
    "equipment.Atenção: o cálculo da vida útil do magnetron não considera o tempo de uso anterior à versão F1.1.0.": "Huomio: magnetronin käyttöiän laskennassa ei huomioida käyttöaikaa ennen versiota F1.1.0.",
    "equipment.Equipamentos com erro": "Laitteet, joissa on virhe",
    "equipment.Em breve você terá acesso a dados importantes enviados pelo forno, como horário de pico, receitas mais executadas, histórico de higienizações, eventos ocorridos e mais! Lembre-se de manter seu equipamento sempre atualizado com as novas versões disponíveis na plataforma.":
    "Pian saat käyttöösi uunin lähettämät tärkeät tiedot, kuten ruuhka-ajat, eniten valmistetut reseptit, puhdistushistorian, tapahtumalokin ja paljon muuta! Muista pitää laitteesi aina ajan tasalla asentamalla alustalla saatavilla olevat uusimmat ohjelmistoversiot.",
    "equipment.Para que a execução da limpeza seja registrada no equipamento e enviada à plataforma, é necessário seguir o passo a passo completo do procedimento no forno. Não é obrigatório assistir aos vídeos dos passos, quando disponíveis.":
    "Jotta puhdistuksen valmistus tallennetaan laitteeseen ja lähetetään alustalle, uunin puhdistusprosessi on suoritettava vaihe vaiheelta loppuun asti. Vaiheisiin liittyvien videoiden katsominen ei ole pakollista, jos niitä on saatavilla.",
    "equipment.Horas de uso": "Käyttötunnit",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.0.6": "Magnetronin käyttötuntien laskenta alkaa ohjelmistoversiosta F1.0.6.",
    "equipment.A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.": "Ohjelmistopäivitys kestää noin 15 minuuttia. Päivityksen aikana uuni käynnistyy uudelleen ja näyttää sinisen näytön, kunnes päivitys on valmis. Virheiden välttämiseksi pidä uuni päällä ja yhdistettynä internetiin. Jos päivität USB-muistitikulta, älä irrota sitä ennen kuin päivitys on valmis.",
    'equipment.Equipamento {name} com software {version} devem ser atualizador via USB. A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.': "Laitteen {name}, jossa on ohjelmisto {version}, on päivitettävä USB:n kautta. Ohjelmistopäivitys kestää noin 15 minuuttia. Päivityksen aikana uuni käynnistyy uudelleen ja näyttää sinisen näytön, kunnes päivitys on valmis. Virheiden välttämiseksi pidä uuni päällä ja yhdistettynä internetiin. Jos päivität USB-muistitikulta, älä irrota sitä ennen kuin päivitys on valmis.",
    "equipment.Observação": "Huomio:",
    "equipment.Para versões ST2.0.0 e superiores, o envio de atualização pela plataforma (Wi-fi) seguirá disponibilizado normalmente.": "Versioista ST2.0.0 alkaen päivitysten lähettäminen alustan (Wi-Fi) kautta on edelleen normaalisti saatavilla.",
    "equipment.Aqui você encontra informações gerais sobre o equipamento;": "Täältä löydät laitteen yleiset tiedot;",
    "equipment.Ao clicar nestes botões você consegue solicitar atendimento para seu forno e exportar seus dados em planilhas do Excel;": "Näillä painikkeilla voit pyytää huoltoa uunillesi ja viedä tiedot Excel-taulukkoon;",
    "equipment.Nos quadros abaixo você encontra informações detalhadas sobre execuções de receitas;": "Alla olevista osioista löydät yksityiskohtaiset tiedot reseptien valmistuksista;",
    "equipment.Horário de pico;": "Ruuhka-aika;",
    "equipment.Informações referentes a higienização;": "Puhdistukseen liittyvät tiedot;",
    "equipment.E histórico de eventos;": "Ja tapahtumahistoria;",
    "equipment.Lembre-se de que é necessário selecionar o período do qual deseja visualizar os dados. É possível fazer isso ao clicar sobre o calendário dos quadros e ao selecionar filtros.": "Muista valita ajanjakso, jonka tiedot haluat nähdä. Voit tehdä sen napsauttamalla osioiden kalenteria ja käyttämällä suodattimia.",
    "equipment.Baixando o arquivo... Ele estará disponível em breve!": "Ladataan tiedostoa... Se on pian saatavilla!",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.1.0": "Magnetronin käyttötuntien laskenta alkaa ohjelmistoversiosta F1.1.0.",
    "equipment.Data de fabricação": "Valmistuspäivä",
    "equipment.manutenção": "huolto",
    "equipment.Ao buscar e localizar um número de série, será aberto um canal temporário diretamente com o forno, permitindo o compartilhamento de seus dados de manutenção. Esses dados não serão armazenados na plataforma, sendo necessário realizar uma nova busca sempre que desejado.":
    "Kun haet ja löydät sarjanumeron, avataan väliaikainen yhteys suoraan uuniin, jolloin huoltotiedot voidaan jakaa. Näitä tietoja ei tallenneta alustalle, joten uusi haku on tehtävä aina tarvittaessa.",
    "equipment.INFORME UM NÚMERO DE SÉRIE E CLIQUE EM BUSCAR": "ANNA SARJANUMERO JA NAPSAUTA HAE",
    "equipment.Apenas os modelos FIT Express / FIT Single Mag / FIT XL com a versão de software F2.1.0 enviarão dados de manutenção. As informações, principalmente as dos contadores, serão contabilizadas a partir dessa versão.":
    "Vain FIT Express-, FIT Single Mag- ja FIT XL -mallit, joissa on ohjelmistoversio F2.1.0, lähettävät huoltotietoja. Tiedot, erityisesti laskureiden arvot, lasketaan tästä versiosta alkaen.",
    "equipment.Procurar número de série": "Etsi sarjanumeroa",
    "equipment.ENCERRAR SESSÃO": "LOPETA ISTUNTO",
    "equipment.Alerta": "Hälytys",
    "equipment.Local": "Sijainti",
    "equipment.Software": "Ohjelmisto",
    "equipment.Forno sem limpeza há": "Uunia ei ole puhdistettu",
    "equipment.Horário de pico": "Ruuhka-aika",
    "equipment.HP": "HP",
    "equipment.RECIPE STARTED": "Reseptin valmistus aloitettu",
    "equipment.RECIPE CANCELED": "Käyttäjä keskeytti reseptin",
    "equipment.RECIPE COMPLETED": "Reseptin valmistus onnistui",
    "equipment.DOOR OPENED RECIPE": "Ovi avattiin reseptin valmistuksen aikana",
    "equipment.DOOR CLOSED RECIPE": "Ovi suljettiin reseptin valmistuksen aikana",
    "equipment.Receitas iniciadas": "Aloitetut reseptit",
    "equipment.Receitas concluídas": "Valmistuneet reseptit",
    "equipment.Receitas interrompidas": "Keskeytetyt reseptit",
    "equipment.Total de receitas concluídas:": "Valmistuneiden reseptien kokonaismäärä:",
    "equipment.TOTAL DE RECEITAS INTERROMPIDAS": "KESKEYTETTYJEN RESEPTIEN KOKONAISMÄÄRÄ",
    "equipment.DOWNLOAD_PROGRESS": "LADATAAN TIEDOSTOA... ODOTA, EDISTYMINEN: {progress}%",
    "equipment.Informe o número de série do forno": "Anna uunin sarjanumero",
    "equipment.preencha o número de série do forno": "Täytä uunin sarjanumero",
    "equipment.NÚMERO DE SÉRIE NÃO CADASTRADO": "SARJANUMEROA EI OLE REKISTERÖITY",
    "equipment.Número de série não encontrado. Por favor, verifique e tente novamente": "Sarjanumeroa ei löytynyt. Tarkista tiedot ja yritä uudelleen.",
    "equipment.Antes de iniciar a atualização, faça o backup das receitas salvas no equipamento para garantir a integridade dos dados. O backup pode ser feito via pen drive ou pela plataforma. Isso permite a recuperação das informações em caso de perda.": "Ennen päivityksen aloittamista varmuuskopioi laitteeseen tallennetut reseptit tietojen säilymisen varmistamiseksi. Varmuuskopio voidaan tehdä USB-muistitikulle tai alustan kautta. Näin tiedot voidaan palauttaa mahdollisen katoamisen jälkeen.",
    "equipment.MENU RECEIVED FROM THE PLATFORM BY FORCED METHOD": "Valikko vastaanotettu alustalta pakotetun päivityksen kautta",
    "equipment.Nome da receita não encontrado": "Reseptin nimeä ei löytynyt",
    "equipment.passos": "{count, plural, one {vaihe} other {vaihetta}}",
    "equipment.minAbbreviation": "min",
    "equipment.secAbbreviation": "s",
    "equipment.Configurações": "Asetukset",
    "equipment.Tempo de preaquecimento": "Esilämmitysaika",
    "equipment.Formato de data": "Päivämäärän muoto",
    "equipment.Formato de hora": "Kellonajan muoto",
    "equipment.Unidade de temperatura": "Lämpötilayksikkö",
    "equipment.Aquecer/dourar mais": "Lisää lämmitystä/ruskistusta",
    "equipment.Fabricante": "Valmistaja",
    "equipment.Voltagem": "Jännite",
    "equipment.Introdução": "Johdanto",
    "equipment.Modelo": "Malli",
    "equipment.Motor": "Moottori",
    "equipment.Hostname": "Isäntänimi",
    "equipment.STATUS DA OPERAÇÃO": "TOIMINNAN TILA",
    "equipment.ÚLTIMA LIMPEZA": "VIIMEISIN PUHDISTUS",
    "equipment.VELOCIDADE DO MOTOR": "MOOTTORIN NOPEUS",
    "equipment.TENSÃO ATUAL": "NYKYINEN JÄNNITE",
    "equipment.Sensores e periféricos": "Anturit ja oheislaitteet",
    "equipment.Contadores": "Laskurit",
    "equipment.HORAS DE USO DO MOTOR": "MOOTTORIN KÄYTTÖTUNNIT",
    "equipment.HORAS DE USO DO MAGNETRON": "MAGNETRONIN KÄYTTÖTUNNIT",
    "equipment.ABERTURAS DE PORTA": "OVEN AVAUKSET",
    "equipment.ATUAÇÃO DO RELE DA POWER": "POWER-RELEEN AKTIVOINTIKERRAT",
    "equipment.ATUAÇÃO DO SENSOR DE PORTA": "OVIANTURIN AKTIVOINTIKERRAT",
    "equipment.RECEITAS EXECUTADAS": "VALMISTETUT RESEPTIT",
    "equipment.LIMPEZAS EXECUTADAS": "SUORITETUT PUHDISTUKSET",
    "equipment.HORAS DE USO DO FILTRO CATALÍTICO": "KATALYYTTISUODATTIMEN KÄYTTÖTUNNIT",
    "equipment.HORAS DE USO DO FILTRO DE AR": "ILMANSUODATTIMEN KÄYTTÖTUNNIT",
    "equipment.CORRENTE DO MAGNETRON": "MAGNETRONIN VIRTA",
    "equipment.Erros": "Virheet",
    "equipment.status online": "verkossa",
    "equipment.status offline": "ei yhteydessä",
    "equipment.software accepted": "ohjelmisto hyväksytty",
    "equipment.menu accepted": "valikko hyväksytty",
    "equipment.software pending": "ohjelmisto odottaa",
    "equipment.menu pending": "valikko odottaa",
    "equipment.software refused": "ohjelmisto hylätty",
    "equipment.menu refused": "valikko hylätty",
    "equipment.Ativado": "Käytössä",
    "equipment.Desativado": "Poistettu käytöstä",
    "equipment.Cozinhando": "Valmistetaan",
    "equipment.Pré-aquecendo": "Esilämmitetään",
    "equipment.Em espera": "Valmiustilassa",
    "equipment.Limpando": "Puhdistetaan",
    "equipment.horas": "tuntia",
    "equipment.Erro CAN": "CAN-virhe",
    "equipment.Erro no sensor de câmara": "Kammioanturin virhe",
    "equipment.Alerta de temperatura alta no painel": "Paneelin korkean lämpötilan hälytys",
    "equipment.Erro de temperatura alta no painel": "Paneelin korkean lämpötilan virhe",
    "equipment.Alerta de comunicação no inversor de frequência": "Taajuusmuuttajan tiedonsiirtohälytys",
    "equipment.Alerta de status no inversor de frequência": "Taajuusmuuttajan tilahälytys",
    "equipment.Alerta na corrente do magnetron": "Magnetronin virtahälytys",
    "equipment.Erro no modelo do equipamento": "Laitemallin virhe",
    "equipment.Erro no módulo de energia": "Energiamoduulin virhe",
    "equipment.Erro I2C": "I2C-virhe",
    "equipment.Erro de temperatura alta na placa": "Piirikortin korkean lämpötilan virhe",
    "equipment.Fechado": "Suljettu",
    "equipment.Aberto": "Avoin",
    "equipment.Câmara": "Kammio",
    "equipment.Placa": "Piirikortti",
    "equipment.Tensão": "Jännite",
    "equipment.Corrente da placa": "Piirikortin virta",
    "equipment.Velocidade do motor": "Moottorin nopeus",
    "equipment.Rele da resistência": "Lämmitysvastuksen rele",
    "equipment.Rele de curto circuito": "Oikosulkurele",
    "equipment.Ventilador radial": "Radiaalipuhallin",
    "equipment.Led vermelho": "Punainen LED",
    "equipment.Led verde": "Vihreä LED",
    "equipment.Led azul": "Sininen LED",
    "equipment.Erro": "Virhe",
    "equipment.Sensor": "Anturi",
    "equipment.Valor": "Arvo",
    "equipment.Manutenção da temperatura": "Lämpötilan ylläpito",
    "equipment.Manutenção": "Ylläpito",
    "equipment.Esfriando": "Jäähdytys",
    "equipment.CEILING SENSOR ERROR": "Kattoanturin virhe",
    "equipment.BALLAST SENSOR ERROR": "Paistoalustan anturin virhe",
    "equipment.VAPORIZER SENSOR ERROR": "Höyrystimen anturin virhe",
    "equipment.EQUIPMENT CONSUMPTION": "Kulutus",
    "equipment.Sensores": "Anturit",
    "equipment.Falta de água": "Veden puute",
    "equipment.Executando Receita": "Reseptiä valmistellaan",
    "equipment.Executando Limpeza": "Puhdistus käynnissä",
    "equipment.Dia": "Päivä",
    "equipment.Semana": "Viikko",
    "equipment.Mês": "Kuukausi",
    "equipment.Tempo": "Aika",
    "equipment.Segunda": "Maanantai",
    "equipment.Terça": "Tiistai",
    "equipment.Quarta": "Keskiviikko",
    "equipment.Quinta": "Torstai",
    "equipment.Sexta": "Perjantai",
    "equipment.Sábado": "Lauantai",
    "equipment.Domingo": "Sunnuntai",
    "equipment.CONSUMO ESTIMADO": "ARVIOITU KULUTUS",
    "equipment.CONSUMO ATUAL": "NYKYINEN KULUTUS",
    "equipment.ECONOMIA COM MODO ECO": "SÄÄSTÖ ECO-TILASSA",
    "equipment.MÉDIA SEMANAL": "VIIKOITTAINEN KESKIARVO",
    "equipment.MÉDIA MENSAL": "KUUKAUSITTAINEN KESKIARVO",
    "equipment.Consumo de energia": "Energiankulutus",
    "equipment.CONSUMO ACUMULADO": "KERTYNYT KULUTUS",
    "equipment.MÉDIA DIÁRIA": "PÄIVITTÄINEN KESKIARVO",
    "equipment.mês selecionado": "valittu kuukausi",
    "equipment.Este valor representa a soma total dos consumos de cada hora do dia.": "Tämä arvo vastaa päivän jokaisen tunnin kulutuksen kokonaissummaa.",
    "equipment.Este valor representa a soma total dos consumos de cada dia.": "Tämä arvo vastaa jokaisen päivän kulutuksen kokonaissummaa.",
    "equipment.Este valor representa a soma total dos consumos de cada semana.": "Tämä arvo vastaa jokaisen viikon kulutuksen kokonaissummaa.",
    "equipment.Este valor representa a soma total dos consumos de cada mês.": "Tämä arvo vastaa jokaisen kuukauden kulutuksen kokonaissummaa.",
    "equipment.Este valor representa a média do consumo das horas, apresentando assim uma estimativa baseada em seu uso.": "Tämä arvo edustaa tuntikohtaisen kulutuksen keskiarvoa ja antaa siten käyttöön perustuvan arvion.",
    "equipment.Este valor representa a média do consumo de cada dia, apresentando assim uma estimativa baseada em seu uso.": "Tämä arvo edustaa päivittäisen kulutuksen keskiarvoa ja antaa siten käyttöön perustuvan arvion.",
    "equipment.Este valor representa a média do consumo semanal, apresentando assim uma estimativa baseada em seu uso.": "Tämä arvo edustaa viikoittaisen kulutuksen keskiarvoa ja antaa siten käyttöön perustuvan arvion.",
    "equipment.Este valor representa a média do consumo dos últimos dois meses, apresentando assim uma estimativa baseada em seu uso.": "Tämä arvo edustaa kahden viimeisen kuukauden keskimääräistä kulutusta ja antaa siten käyttöön perustuvan arvion.",
    "equipment.Este valor representa a soma total da economia de consumo de cada hora do dia com a utilização do modo Eco.": "Tämä arvo edustaa Eco-tilan käytöllä saavutettua päivän jokaisen tunnin kulutussäästön kokonaissummaa.",
    "equipment.Este valor representa a soma total da economia de consumo de cada dia com a utilização do modo Eco.": "Tämä arvo edustaa Eco-tilan käytöllä saavutettua päivittäisen kulutussäästön kokonaissummaa.",
    "equipment.Este valor representa a soma total da economia de consumo semanal com a utilização do modo Eco.": "Tämä arvo edustaa Eco-tilan käytöllä saavutettua viikoittaisen kulutussäästön kokonaissummaa.",
    "equipment.Este valor representa a soma total da economia de consumo mensal com a utilização do modo Eco.": "Tämä arvo edustaa Eco-tilan käytöllä saavutettua kuukausittaisen kulutussäästön kokonaissummaa.",
    "equipment.Este valor representa a média de consumo dos últimos 7 dias, desconsiderando o dia atual.": "Tämä arvo edustaa viimeisten 7 päivän keskimääräistä kulutusta kuluvan päivän ulkopuolelta.",
    "equipment.Este valor representa a média de consumo das últimas 4 semanas.": "Tämä arvo edustaa viimeisten 4 viikon keskimääräistä kulutusta.",
    "equipment.Este valor representa a média de consumo dos últimos 2 meses, desconsiderando o mês atual.": "Tämä arvo edustaa viimeisten 2 kuukauden keskimääräistä kulutusta kuluvan kuukauden ulkopuolelta.",
    "equipment.Lista de consumo de energia": "Energiankulutusluettelo",
    "equipment.Período": "Jakso",
    "equipment.Consumo (kWh)": "Kulutus (kWh)",
    "equipment.Economia com ECO (kWh)": "Säästö ECO-tilassa (kWh)",
    "equipment.Total": "Yhteensä",
    "equipment.Sensor de RI": "RI-anturi",
    "equipment.HUMIDITY SENSOR ERROR": "Kosteusanturin virhe",
    "equipment.TEMPERATURE SENSOR ERROR": "Lämpötila-anturin virhe",
    "equipment.WATER FILTER CLEANING COMPLETED": "Vesisuodattimen vaihto suoritettu",
    "equipment.WATER FILTER CLEANING REJECTED": "Vesisuodattimen vaihto hylätty",
    "equipment.HOOD TURNED ON": "Liesikupu päällä",
    "equipment.HOOD TURNED OFF": "Liesikupu pois päältä",
    "equipment.AUTOMATIC PREHEATING REJECTED": "Automaattinen esilämmitys hylätty",
    "equipment.Receitas Forno": "Uunin reseptit",
    "equipment.Receitas Fermentadora": "Kohotuskaapin reseptit",
    "equipment.média diária": "päivittäinen keskiarvo",
    "equipment.média de execução diária": "päivittäisten suoritusten keskiarvo",
    "equipment.FERMENTADORA": "KOHOTUSKAAPPI",
    "equipment.FORNO": "UUNI",
    "equipment.DIA": "PÄIVÄ",
    "equipment.Baixado": "Ladattu",
    "equipment.A limpeza diária do equipamento auxilia em seu bom funcionamento e impacta na garantia.": "Laitteen päivittäinen puhdistus edistää sen moitteetonta toimintaa ja vaikuttaa takuuseen.",
    "equipment.Desde a vinculação do equipamento ao IOK": "Laitteen liittämisestä IOK:hon lähtien",
    "equipment.Total desde a vinculação do equipamento ao IOK": "Yhteensä laitteen liittämisestä IOK:hon lähtien",
    "equipment.Receitas do forno": "Uunin reseptit",
    "equipment.Receitas da fermentadora": "Kohotuskaapin reseptit",
    "equipment.FERM.": "KOHOT.",
    "equipment.Fermentadora": "Kohotuskaappi",
    "equipment.Coifa": "Liesikupu",
    "equipment.Preaquecimento automático": "Automaattinen esilämmitys",
    "equipment.nivel": "taso",
    "equipment.Fermentadora ligada": "Kohotuskaappi päällä",
    "equipment.Fermentadora desligada": "Kohotuskaappi pois päältä",
    "equipment.Forno desligado": "Uuni pois päältä",
    "equipment.Equipamento ligado": "Laite päällä",
    "equipment.Equipamento desligado": "Laite pois päältä",
    "equipment.visualizar haccp": "näytä HACCP",
    "equipment.HACCP": "HACCP",
    "equipment.Atualizar Equip.": "Päivitä laite",
    "equipment.Consumo de agua por receita": "Vedenkulutus reseptiä kohden",
    "equipment.Consumo de energia por receita": "Energiankulutus reseptiä kohden",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE AGUA POR RECEITA :(": "VEDENKULUTUKSESTA RESEPTIÄ KOHDEN EI OLE VIELÄ TIETOJA :(",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE ENERGIA POR RECEITA :(": "ENERGIANKULUTUKSESTA RESEPTIÄ KOHDEN EI OLE VIELÄ TIETOJA :(",
    "equipment.LITROS CONSUMIDOS NO DIA": "PÄIVÄN AIKANA KULUTETUT LITRAT",
    "equipment.ENERGIA CONSUMIDA NO DIA": "PÄIVÄN AIKANA KULUTETTU ENERGIA",
    "equipment.CONSUMO ACUMULADO SEMANAL": "VIIKOITTAINEN KERTYNYT KULUTUS",
    "equipment.CONSUMO ACUMULADO MENSAL": "KUUKAUSITTAINEN KERTYNYT KULUTUS",
    "equipment.Receitas": "Reseptit",
    "equipment.Consumo (L)": "Kulutus (L)",
    "equipment.Exec. dia - (L)": "Valm. päivä - (L)",
    "equipment.Exec. semana - (L)": "Valm. viikko - (L)",
    "equipment.Exec. mês - (L)": "Valm. kuukausi - (L)",
    "equipment.Exec. dia - (kWh)": "Valm. päivä - (kWh)",
    "equipment.Exec. semana - (kWh)": "Valm. viikko - (kWh)",
    "equipment.Exec. mês - (kWh)": "Valm. kuukausi - (kWh)",
    "equipment.Agua consumida (litros)": "Kulutettu vesi (litraa)",
    "equipment.Energia consumida (kWh)": "Kulutettu energia (kWh)",
    "equipment.temperatura da câmara": "Kammion lämpötila",
    "equipment.temperatura do vapor": "Höyryn lämpötila",
    "equipment.último evento listado": "Viimeisin lueteltu tapahtuma",
    "equipment.temperatura da sonda": "Anturin lämpötila",
    "equipment.porta": "Ovi",
    "equipment.temperatura": "Lämpötila",
    "equipment.temperatura atual": "Nykyinen lämpötila",
    "equipment.média de oscilação diária": "Päivittäinen keskimääräinen vaihtelu",
    "equipment.oscilação diária da temperatura": "Päivittäinen lämpötilan vaihtelu",
    "equipment.temperature.sectionTitle": "Lämpötila",
    "equipment.temperature.currentChamber": "KAMMION NYKYINEN LÄMPÖTILA:",
    "equipment.temperature.currentProbe": "ANTURIN NYKYINEN LÄMPÖTILA:",
    "equipment.temperature.currentSteam": "HÖYRYN NYKYINEN LÄMPÖTILA:",
    "equipment.temperature.dailyOscillation": "Päivittäinen lämpötilan vaihtelu",
    "equipment.temperature.chamberShort": "Kammio",
    "equipment.temperature.probeShort": "Anturi",
    "equipment.temperature.axisLabel": "Lämpötila {unit}",
    "equipment.temperature.dailyAverage": "PÄIVITTÄINEN KESKIARVO",
    "equipment.temperature.weeklyAverage": "VIIKOITTAINEN KESKIARVO",
    "equipment.temperature.monthlyAverage": "KUUKAUSITTAINEN KESKIARVO",
    "equipment.temperature.lastListedEvent": "Viimeisin lueteltu tapahtuma",
    "equipment.temperature.door": "Ovi",
    "equipment.temperature.open": "AUKI",
    "equipment.temperature.closed": "KIINNI",
    "equipment.temperature.defineTimeRange": "Määritä aikaväli:",
    "equipment.temperature.until": "klo",
    "equipment.cleaningType.smart": "Älykäs puhdistus",
    "equipment.cleaningType.light": "Kevyt puhdistus",
    "equipment.cleaningType.medium": "Keskitasoinen puhdistus",
    "equipment.cleaningType.heavy": "Tehopuhdistus",
    "equipment.cleaningType.decalcifying": "Kalkinpoistopuhdistus",
    "equipment.cleaningType.security": "Turvapuhdistus",
    "equipment.cleaningType.rinse": "Huuhtelu",
    "equipment.cleaningType.custom": "Mukautettu puhdistus",
    "equipment.cleaningTypeShort.smart": "Älykäs",
    "equipment.cleaningTypeShort.light": "Kevyt",
    "equipment.cleaningTypeShort.medium": "Keskitaso",
    "equipment.cleaningTypeShort.heavy": "Teho",
    "equipment.cleaningTypeShort.decalcifying": "Kalkinpoisto",
    "equipment.cleaningTypeShort.security": "Turva",
    "equipment.cleaningTypeShort.rinse": "Huuhtelu",
    "equipment.cleaningTypeShort.custom": "Mukautettu",
    "equipment.gerar gráficos": "luo kaaviot",
    "equipment.Realizada": "Suoritettu",
    "equipment.Recomendada": "Suosit.",
    "equipment.Dias da semana": "Viikonpäivät",
    "equipment.Horário 24h": "24 h",
    "equipment.seg": "Ma",
    "equipment.ter": "Ti",
    "equipment.qua": "Ke",
    "equipment.qui": "To",
    "equipment.sex": "Pe",
    "equipment.sab": "La",
    "equipment.dom": "Su",
    "equipment.Desconhecido": "Tuntematon",
    "equipment.AINDA NÃO HÁ DADOS DE CONSUMO DE ENERGIA AQUI :(": "TÄÄLLÄ EI OLE VIELÄ ENERGIANKULUTUSTIETOJA :(",
    "equipment.monthShort.Jan": "Tam",
    "equipment.monthShort.Fev": "Hel",
    "equipment.monthShort.Mar": "Maa",
    "equipment.monthShort.Abr": "Huh",
    "equipment.monthShort.Mai": "Tou",
    "equipment.monthShort.Jun": "Kes",
    "equipment.monthShort.Jul": "Hei",
    "equipment.monthShort.Ago": "Elo",
    "equipment.monthShort.Set": "Syy",
    "equipment.monthShort.Out": "Lok",
    "equipment.monthShort.Nov": "Mar",
    "equipment.monthShort.Dez": "Jou",
    "equipment.settingsChange.category": "Parametrien muutos",
    "equipment.settingsChange.factoryTitle": "Teknisen parametrin muutos",
    "equipment.settingsChange.userTitle": "Käyttäjäparametrin muutos",
    "equipment.settingsChange.changedTo": "{label} muutettu arvoon {value}",
    "equipment.settingsChange.hardResetExecuted": "Hard reset suoritettu",
    "equipment.settingsChange.userFactoryResetExecuted": "Käyttäjän tehdasasetusten palautus suoritettu",
    "equipment.settingsChange.magSensorEnabled": "magnetronianturi",
    "equipment.settingsChange.serialNumber": "sarjanumero",
    "equipment.settingsChange.manufactureDate": "valmistuspäivä",
    "equipment.settingsChange.inverterType": "invertterin tyyppi",
    "equipment.settingsChange.preHeatMotorSpeed": "esilämmitysmoottorin nopeus",
    "equipment.settingsChange.voltage": "jännite",
    "equipment.settingsChange.oemModeEnabled": "OEM-tila",
    "equipment.settingsChange.controlDoor": "oven ohjaus",
    "equipment.settingsChange.hardReset": "Hard reset",
    "equipment.settingsChange.preHeatTemperatureOne": "esilämmityslämpötila 1",
    "equipment.settingsChange.preHeatTemperatureTwo": "esilämmityslämpötila 2",
    "equipment.settingsChange.preHeatTime": "esilämmitysaika",
    "equipment.settingsChange.preHeatTwoEnabled": "esilämmitys 2",
    "equipment.settingsChange.userFactoryReset": "Käyttäjän tehdasasetusten palautus",
    "equipment.settingsChange.enableManualMode": "manuaalitila",
    "equipment.settingsChange.enableFavorites": "suosikit",
    "equipment.settingsChange.enableHeatBrown": "lisää lämmitystä/ruskistusta",
    "equipment.settingsChange.enableRepeatRecipe": "toista resepti",
    "equipment.settingsChange.enableOperatorMode": "käyttäjätila",
    "equipment.settingsChange.enableAutoImport": "automaattinen tuonti",
    "equipment.settingsChange.enableRecipePreRunMessage": "reseptin valmistelua edeltävä viesti",
    "equipment.settingsChange.controlDoorTwoInputs": "2 tuloa",
    "equipment.settingsChange.controlDoorThreeInputs": "3 tuloa",
    
    //LOJAS
    "store.Procurar loja": "Etsi myymälää",
    "store.Excluir": "Poista",
    "store.Editar": "Muokkaa",
    "store.nome": "Nimi",
    "store.equipamentos": "Laitteet",
    "store.Equipamentos vinculados": "Liitetyt laitteet",
    "store.cidade": "Kaupunki",
    "store.estado": "Osavaltio",
    "store.salvar": "tallenna",
    "store.cadastrar loja": "rekisteröi myymälä",
    "store.Nome fantasia": "Toiminimi",
    "store.Preencha o nome da loja": "Täytä myymälän nimi",
    "store.CNPJ": "CNPJ",
    "store.Preencha o CNPJ da loja": "Täytä myymälän CNPJ",
    "store.CEP": "Postinumero",
    "store.Preencha o CEP da loja": "Täytä myymälän postinumero",
    "store.Informe o nome fantasia": "Anna toiminimi",
    "store.Cidade": "Kaupunki",
    "store.Informe a cidade": "Anna kaupunki",
    "store.Preencha a cidade": "Täytä kaupunki",
    "store.UF": "Osavaltio",
    "store.Preencha o UF da loja": "Täytä myymälän osavaltio",
    "store.Bairro": "Kaupunginosa",
    "store.Informe o bairro": "Anna kaupunginosa",
    "store.Preencha o bairro da loja": "Täytä myymälän kaupunginosa",
    "store.Endereço": "Osoite",
    "store.Informe o endereço": "Anna osoite",
    "store.Preencha o endereço da loja": "Täytä myymälän osoite",
    "store.Nº": "Nro",
    "store.Preencha o número": "Täytä numero",
    "store.Loja cadastrada com sucesso": "Myymälä rekisteröity onnistuneesti",
    "store.Erro ao adicionar loja. Tente novamente":
    "Virhe lisättäessä myymälää. Yritä uudelleen",
    "store.Loja deletada com sucesso": "Myymälä poistettu onnistuneesti",
    "store.Erro ao deletar loja. Tente novamente mais tarde":
    "Virhe poistettaessa myymälää. Yritä myöhemmin uudelleen",
    "store.AINDA NÃO HÁ NENHUMA LOJA CADASTRADA :(": "MYYMÄLÖITÄ EI OLE VIELÄ REKISTERÖITY :(",
    "store.EXCLUIR LOJA": "POISTA MYYMÄLÄ",
    "store.Você deseja excluir a loja da plataforma IOK?": "Haluatko poistaa myymälän IOK-alustalta?",
    "store.Ao fazer isso, os equipamentos atrelados à ela não terão vínculo com nenhuma loja, a menos que os vincule novamente.": "Tämän jälkeen siihen liitetyillä laitteilla ei enää ole yhteyttä mihinkään myymälään, ellet liitä niitä uudelleen.",
    "store.loja editada com sucesso": "Myymälä muokattu onnistuneesti",
    "store.não foi possível editar a loja. Tente novamente mais tarde": "Myymälän muokkaaminen ei onnistunut. Yritä myöhemmin uudelleen",
    "store.editar loja": "muokkaa myymälää",
    "store.Procurar grupo de equipamentos": "Etsi laitoryhmää",
    "store.cadastrar grupo": "rekisteröi ryhmä",
    "store.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "RYHMIÄ EI OLE VIELÄ REKISTERÖITY :(",
    "store.description.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "Napsauta oikeassa yläkulmassa olevaa painiketta ja lisää ryhmiä.",
    "store.cadastrar grupo de equipamentos": "rekisteröi laitoryhmä",
    "store.grupo de equipamentos cadastrado com sucesso!": "Laitoryhmä rekisteröity onnistuneesti!",
    "store.não foi possível cadastrar o grupo. Tente novamente mais tarde": "Ryhmän rekisteröinti ei onnistunut. Yritä myöhemmin uudelleen",
    "store.Nome do grupo": "Ryhmän nimi",
    "store.informe o nome do grupo": "Anna ryhmän nimi",
    "store.preencha o nome do grupo": "Täytä ryhmän nimi",
    "store.Grupo de equipamentos deletado com sucesso!": "Laitoryhmä poistettu onnistuneesti!",
    "store.Erro ao deletar o grupo. Tente novamente mais tarde": "Virhe poistettaessa ryhmää. Yritä myöhemmin uudelleen",
    "store.EXCLUIR GRUPO DE EQUIPAMENTOS": "POISTA LAITORYHMÄ",
    "store.Você deseja excluir este grupo de equipamentos da plataforma IOK?": "Haluatko poistaa tämän laitoryhmän IOK-alustalta?",
    "store.Ao fazer isso, os equipamentos atrelados à ele não terão vínculo com nenhum grupo, a menos que os vincule novamente.": "Tämän jälkeen siihen liitetyillä laitteilla ei enää ole yhteyttä mihinkään ryhmään, ellet liitä niitä uudelleen.",
    "store.grupo de equipamentos editado com sucesso!": "Laitoryhmä muokattu onnistuneesti!",
    "store.não foi possível editar o grupo. Tente novamente mais tarde": "Ryhmän muokkaaminen ei onnistunut. Yritä myöhemmin uudelleen",
    "store.editar grupo de equipamentos": "muokkaa laitoryhmää",
    "store.CEP não encontrado no Brasil": "Postinumeroa ei löytynyt Brasiliasta",
    "store.Cadastrar": "Rekisteröi",
    "store.Equipamentos vinculados": "Liitetyt laitteet",
    
    // NAVBAR
    "navbar.home": "etusivu",
    "navbar.cookbook": "cookbook",
    "navbar.my menus": "omat valikot",
    "navbar.equipment": "laitteet",
    "navbar.users": "käyttäjät",
    "navbar.calls": "huoltopyynnöt",
    "navbar.settings": "asetukset",
    "navbar.help": "ohje",
    "navbar.logout": "Kirjaudu ulos",
    "navbar.Editar conta": "Muokkaa tiliä",
    "navbar.API Externa": "Ulkoinen API",
    "navbar.companhias": "yritykset",
    "navbar.information": "IOK-tiedot",
    
    // FOOTERBAR
    "footerBar.menu": "Valikko",
    "footerBar.cookbook": "Cookbook",
    "footerBar.home": "Etusivu",
    "footerBar.menus": "Valikot",
    "footerBar.notifications": "Ilmoitukset",
    
    //ATENDIMENTOS
    "calls.ATENDIMENTOS EM ABERTO": "AVOIMET HUOLTOPYYNNÖT",
    "calls.ATENDIMENTOS ENCERRADOS": "SULJETUT HUOLTOPYYNNÖT",
    
    //MAP
    "map.título": "Sijainti",
    "map.erro": "virhe!",
    "map.mensagem de erro": "kartan lataaminen ei onnistunut.",
    "map.Localização não disponível": "Sijainti ei ole saatavilla",
    
    //MODAL
    "modal.CONFIRMAR": "VAHVISTA",
    "modal.Salvar alterações": "Tallenna muutokset",
    "Modal.Há alterações não salvas nos parâmetros dos passos ":
    "Vaiheiden parametreihin on tallentamattomia muutoksia ",
    "Modal.Como deseja proceder?": "Miten haluat jatkaa?",
    "Modal.Avaliar alterações realizadas": "Tarkista tehdyt muutokset",
    "Modal.Descartar alterações": "Hylkää muutokset",
    
    //USUÁRIOS
    "user.Nome": "Nimi",
    "user.E-mail": "Sähköposti",
    "user.Permissão": "Käyttöoikeus",
    "user.Loja": "Myymälä",
    "user.Status": "Tila",
    "user.Excluir": "Poista",
    "user.Editar": "Muokkaa",
    "user.Procurar usuário": "Etsi käyttäjää",
    "user.ADICIONAR USUÁRIO": "LISÄÄ KÄYTTÄJÄ",
    "user.AINDA NÃO HÁ NENHUM USUÁRIO CADASTRADO :(": "KÄYTTÄJIÄ EI OLE VIELÄ REKISTERÖITY :(",
    "user.+ Usuário": "+ Käyttäjä",
    "user.Informe o nome do usuário": "Anna käyttäjän nimi",
    "user.Preencha o nome do usuário": "Täytä käyttäjän nimi",
    "user.Informe o e-mail do usuário": "Anna käyttäjän sähköpostiosoite",
    "user.Preencha com um e-mail válido": "Anna kelvollinen sähköpostiosoite",
    "user.Administrador": "Järjestelmänvalvoja",
    "user.Usuário": "Käyttäjä",
    "user.Preencha o telefone do usuário": "Täytä käyttäjän puhelinnumero",
    "user.Selecione a permissão do usuário": "Valitse käyttäjän käyttöoikeus",
    "user.Ativo": "Aktiivinen",
    "user.Inativo": "Ei aktiivinen",
    "user.Usuário deletado da plataforma com sucesso!": "Käyttäjä poistettu onnistuneesti alustalta!",
    "user.Ocorreu um erro. Tente novamente mais tarde": "Tapahtui virhe. Yritä myöhemmin uudelleen",
    "user.EXCLUIR USUÁRIO": "POISTA KÄYTTÄJÄ",
    "user.delete.paragrafo 1": "Haluatko poistaa käyttäjän IOK-alustalta?",
    "user.delete.paragrafo 2": "Tämän jälkeen hän menettää pääsyn kaikkiin alustan toimintoihin, ellei häntä lisätä alustalle uudelleen rekisteröintiohjeiden mukaisesti.",
    "user.EDITAR USUÁRIO": "MUOKKAA KÄYTTÄJÄÄ",
    "user.Usuário editado com sucesso!": "Käyttäjä muokattu onnistuneesti!",
    "user.Não foi possível editar este usuário. Por favor, tente mais tarde": "Tämän käyttäjän muokkaaminen ei onnistunut. Yritä myöhemmin uudelleen",
    "user.INFORMAÇÕES DO USUÁRIO": "KÄYTTÄJÄN TIEDOT",
    "user.Telefone": "Puhelin",
    "user.Não foi possível cadastrar este usuário. Por favor, tente mais tarde": "Tämän käyttäjän rekisteröinti ei onnistunut. Yritä myöhemmin uudelleen",
    "user.Usuário adicionado com sucesso!": "Käyttäjä lisätty onnistuneesti!",
    "user.CRIAR TIPO DE USUÁRIO": "LUO KÄYTTÄJÄTYYPPI",
    "user.Criar novo tipo de usuário": "Luo uusi käyttäjätyyppi",
    "user.Adicionar novo usuário": "Lisää uusi käyttäjä",
    "user.Permissões": "Käyttöoikeudet",
    "user.Preencha o nome do novo tipo de usuário": "Anna uuden käyttäjätyypin nimi",
    "user.Selecione pelo menos uma permissão": "Valitse vähintään yksi käyttöoikeus",
    "user.Não foi possível carregar as permissões": "Käyttöoikeuksia ei voitu ladata",
    "user.Tipo de usuário criado com sucesso!": "Käyttäjätyyppi luotu onnistuneesti!",
    "user.Não foi possível criar este novo tipo de usuário. Por favor, tente mais tarde": "Uuden käyttäjätyypin luominen ei onnistunut. Yritä myöhemmin uudelleen",
    "user.Não foi possível carregar os tipos de usuário da companhia": "Yrityksen käyttäjätyyppejä ei voitu ladata",
    "user.Tipo de usuário": "Käyttäjätyyppi",
    "user.E-mail já cadastrado na plataforma. Informe um novo e-mail": "Sähköpostiosoite on jo rekisteröity alustalle. Anna uusi sähköpostiosoite",
    "user.UNIR CONTAS": "YHDISTÄ TILIT",
    "user.ID da companhia": "Yrityksen ID",
    "user.Digite o ID da companhia que deseja unir a sua conta": "Anna sen yrityksen ID, jonka haluat yhdistää tiliisi",
    "user.Preencha o ID da companhia": "Täytä yrityksen ID",
    "user.O administrador da outra conta poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "Toisen tilin järjestelmänvalvoja löytää ID:n napsauttamalla käyttäjänimeään näytön oikeassa yläkulmassa olevasta valikosta.",
    "user.O administrador da outra conta receberá um e-mail para aceitar sua solicitação. Assim que for aceita, a união das duas contas será realizada!": "Toisen tilin järjestelmänvalvoja saa sähköpostiviestin pyyntösi hyväksymiseksi. Heti kun pyyntö hyväksytään, tilit yhdistetään!",
    "user.Não foi possível solicitar a união de contas. Por favor, confirme o ID ou tente mais tarde": "Tilien yhdistämispyynnön lähettäminen ei onnistunut. Tarkista ID tai yritä myöhemmin uudelleen",
    "user.SOLICITAÇÃO APROVADA COM SUCESSO": "PYYNTÖ HYVÄKSYTTY ONNISTUNEESTI",
    "user.AGUARDE ENQUANTO REALIZAMOS A UNIÃO DAS CONTAS. ESTE PROCESSO PODE LEVAR ALGUNS MINUTOS...": "ODOTA, KUN YHDISTÄMME TILIT. TÄMÄ PROSESSI VOI KESTÄÄ MUUTAMAN MINUUTIN...",
    "user.UNIÃO DE CONTAS FINALIZADA COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "TILIEN YHDISTÄMINEN ONNISTUI! SIIRRY ALUSTALLE NAPSAUTTAMALLA ALLA OLEVAA PAINIKETTA.",
    "user.NÃO CONSEGUIMOS REALIZAR A UNIÃO DAS CONTAS. POR FAVOR, TENTE NOVAMENTE. SE O PROBLEMA PERSISTIR, ENTRE EM CONTATO COM NOSSO SUPORTE.": "TILIEN YHDISTÄMINEN EI ONNISTUNUT. YRITÄ UUDELLEEN. JOS ONGELMA JATKUU, OTA YHTEYTTÄ ASIAKASTUKEEMME.",
    "user.possui todos os acessos": "on kaikki käyttöoikeudet",
    "user.possui o acesso das abas cookbook, meus menus e equipamentos": "on käyttöoikeus Cookbook-, Omat valikot- ja Laitteet-välilehtiin",
    "user.possui apenas o acesso da aba cookbook": "on käyttöoikeus vain Cookbook-välilehteen",
    "user.possui apenas o acesso da aba equipamentos": "on käyttöoikeus vain Laitteet-välilehteen",
    "user.possui apenas o acesso da aba meus menus": "on käyttöoikeus vain Omat valikot -välilehteen",
    "user.Grupo de equipamentos": "Laiteryhmä",
    "user.Informe o telefone do usuário": "Anna käyttäjän puhelinnumero",
    "user.Nenhum grupo criado": "Ryhmiä ei ole luotu",
    "user.Digite o ID da companhia que terá acesso à sua conta": "Anna sen yrityksen ID, jolla on käyttöoikeus tiliisi",
    "user.Ao informar um ID para unir contas com sua companhia, esteja ciente de que o novo usuário também se tornará Administrador da conta de sua companhia. É importante informar que a partir do momento em que um usuário aceitar unir contas com sua companhia, a companhia pertencente a ele deixará de existir.": "Kun annat yrityksen ID:n tilien yhdistämiseksi yritykseesi, huomioi, että uudesta käyttäjästä tulee myös yrityksesi tilin järjestelmänvalvoja. Huomaa myös, että siitä hetkestä lähtien, kun käyttäjä hyväksyy tilien yhdistämisen yritykseesi, hänen aiempi yrityksensä lakkaa olemasta.",
    "user.Exemplo: Sua conta: 001 | Outra conta: 111. Depois de unir contas com você, a outra conta passará a ser 001.": "Esimerkki: Tilisi: 001 | Toinen tili: 111. Kun tilit on yhdistetty tiliisi, toisen tilin tunnukseksi tulee 001.",
    "user.Tela de Equipamentos": "Laitteet-näyttö",
    "user.Tela de Meus Menus": "Omat valikot -näyttö",
    "user.Tela do Cookbook": "Cookbook-näyttö",
    "user.Tela de Usuários": "Käyttäjät-näyttö",
    "user.Aba de Suporte": "Tuki-välilehti",
    "user.Usuário Comum": "Peruskäyttäjä",
    "user.Usuário do Cookbook": "Cookbook-käyttäjä",
    "user.Usuário de Equipamentos": "Laitteiden käyttäjä",
    "user.Usuário de Meus Menus": "Omat valikot -käyttäjä",
    "user.Você deseja excluir seu acesso da plataforma IOK?": "Haluatko poistaa käyttöoikeutesi IOK-alustalta?",
    "user.Ao fazer isso, você perderá o acesso a todas as ferramentas da plataforma e, para voltar a acessá-la, será necessário ser adicionado à ela novamente.": "Tämän jälkeen menetät käyttöoikeuden kaikkiin alustan toimintoihin. Jotta voit käyttää alustaa uudelleen, sinut on lisättävä sille uudelleen.",
    "user.CONFIRMAÇÃO": "VAHVISTUS",
    "user.Confirme sua senha": "Vahvista salasanasi",
    "user.Senha incorreta": "Virheellinen salasana",
    "user.Os equipamentos e menus criados por ele serão transferidos para o seu nome.": "Hänen luomansa laitteet ja valikot siirretään sinun nimiisi.",
    
    
    //TUTORIAIS
    "tutorial.Fechar": "Sulje",
    "tutorial.Fim": "Lopeta",
    "tutorial.Próximo": "Seuraava",
    "tutorial.Abrir": "Avaa",
    "tutorial.Pular tutorial": "Ohita opastus",
    "tutorial.Editar detalhes da receita": "Muokkaa reseptin tietoja",
    "tutorial.Agora você pode adicionar mais detalhes às suas receitas e deixá-las ainda mais completas. Clique em Editar detalhes e preencha as informações necessárias.": "Voit nyt lisätä resepteihisi enemmän tietoja ja tehdä niistä entistä täydellisempiä. Napsauta Muokkaa tietoja ja täytä tarvittavat tiedot.",
    "tutorial.Salvar edição da receita": "Tallenna reseptin muutokset",
    "tutorial.Depois de informar mais detalhes da receita, clique em Salvar.": "Kun olet lisännyt reseptiin lisätiedot, napsauta Tallenna.",
    "tutorial.Editar registro de um equipamento": "Muokkaa laitteen tietoja",
    "tutorial.Para completar o registro de seus equipamentos, abra o sivuvalikko, clique em Editar e preencha as informações de Categoria e Loja.": "Täydentääksesi laitteidesi tiedot avaa sivuvalikko, napsauta Muokkaa ja täytä Kategoria- ja Myymälä-tiedot.",
    "tutorial.Editar usuário": "Muokkaa käyttäjää",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente a Loja a qual ele faz parte.": "Täydentääksesi käyttäjän tiedot avaa sivuvalikko, napsauta Muokkaa ja täytä tiedot myymälästä, johon käyttäjä kuuluu.",
    "tutorial.Salvar edições de um equipamento": "Tallenna laitteen muutokset",
    "tutorial.Depois de completar o registro de seus equipamentos, clique em Salvar.": "Kun olet täydentänyt laitteidesi tiedot, napsauta Tallenna.",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em uma loja, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Napsauttamalla myymälään rekisteröidyn laitteen riviä voit tarkastella lisätilastoja ja -tietoja sekä pyytää huoltoa tai lähettää päivityksiä.",
    "tutorial.Para visualizar mais informações sobre a loja, como localização e receitas mais preparadas, clique sobre a linha da unidade que deseja analisar.": "Jos haluat nähdä lisää tietoja myymälästä, kuten sijainnin ja eniten valmistetut reseptit, napsauta sen yksikön riviä, jota haluat tarkastella.",
    "tutorial.Criar receita": "Luo resepti",
    "tutorial.No cookbook você pode criar suas próprias receitas! Clique em Criar Receita e preencha todas as informações necessárias.": "Cookbookissa voit luoda omia reseptejäsi! Napsauta Luo resepti ja täytä kaikki tarvittavat tiedot.",
    "tutorial.Editar ou excluir um usuário": "Muokkaa tai poista käyttäjä",
    "tutorial.Para excluir ou editar as informações de um usuário já cadastrado, clique no menu lateral e selecione a opção desejada.": "Voit muokata tai poistaa rekisteröidyn käyttäjän tiedot napsauttamalla sivuvalikkoa ja valitsemalla haluamasi toiminnon.",
    "tutorial.Gerenciamento de usuários": "Käyttäjien hallinta",
    "tutorial.Aqui você pode gerenciar seus usuários com mais facilidade. Ao clicar em + Usuário, você poderá adicionar um novo usuário ou criar um novo tipo de usuário.": "Täällä voit hallita käyttäjiäsi helpommin. Napsauttamalla + Käyttäjä voit lisätä uuden käyttäjän tai luoda uuden käyttäjätyypin.",
    "tutorial.Suas receitas": "Reseptisi",
    "tutorial.Pelo cookbook você também encontra suas próprias receitas, além de poder criá-las! Clique em Receitas Salvas para visualizar as receitas que foram salvas do cookbook da Prática e também as criadas por você.": "Cookbookista löydät myös omat reseptisi ja voit luoda uusia! Napsauta Tallennetut reseptit nähdäksesi sekä Prátican Cookbookista tallennetut että itse luomasi reseptit.",
    "tutorial.Filtros do Cookbook": "Cookbookin suodattimet",
    "tutorial.Para facilitar a navegação pelas receitas, você pode aplicar filtros a elas. Basta clicar no filtro desejado e escolher uma de suas opções.": "Voit helpottaa reseptien selaamista käyttämällä suodattimia. Napsauta haluamaasi suodatinta ja valitse jokin sen vaihtoehdoista.",
    "tutorial.Cookbook": "Cookbook",
    "tutorial.No cookbook, em Receitas Disponíveis, você encontrará as receitas criadas pelos Chefs da Prática e poderá utilizá-las sempre que quiser.": "Cookbookin Käytettävissä olevat reseptit -osiossa löydät Prátican keittiömestareiden luomat reseptit, joita voit käyttää milloin tahansa.",
    "tutorial.Atualizar equipamentos": "Päivitä laitteet",
    "tutorial.Para enviar uma atualização a seus equipamentos, clique em Atualizar Equipamentos, selecione os modelos que deseja atualizar e a forma como deseja realizar essa atualização - via wi-fi ou pen drive. Depois disso, clique em Confirmar.": "Lähettääksesi päivityksen laitteillesi napsauta Päivitä laitteet, valitse päivitettävät mallit ja haluamasi päivitystapa – Wi-Fi:n tai USB-muistitikun kautta. Napsauta lopuksi Vahvista.",
    "tutorial.Adicionar equipamento": "Lisää laite",
    "tutorial.Para adicionar um equipamento à sua conta, clique em Adicionar Equipamento e preencha as informações do modal. Depois disso, clique em Salvar.": "Lisätäksesi laitteen tilillesi napsauta Lisää laite ja täytä ponnahdusikkunan tiedot. Napsauta lopuksi Tallenna.",
    "tutorial.Editar equipamento": "Muokkaa laitetta",
    "tutorial.Para desvincular um equipamento ou editar suas informações, clique no menu lateral e selecione a opção desejada.": "Irrottaaksesi laitteen tai muokataksesi sen tietoja napsauta sivuvalikkoa ja valitse haluamasi toiminto.",
    "tutorial.Seus equipamentos": "Laitteesi",
    "tutorial.Aqui você visualizará todos os equipamentos cadastrados em sua plataforma.": "Täällä näet kaikki alustallesi rekisteröidyt laitteet.",
    "tutorial.Restaurar arquivos": "Palauta tiedostoja",
    "tutorial.Para restaurar um arquivo excluído ou deletá-lo permanentemente, clique no menu lateral e selecione a opção desejada.": "Palauttaaksesi poistetun tiedoston tai poistaaksesi sen pysyvästi napsauta sivuvalikkoa ja valitse haluamasi toiminto.",
    "tutorial.Lixeira": "Roskakori",
    "tutorial.Os menus excluídos serão mantidos na Lixeira por 30 dias. Depois desse prazo serão excluídos permanentemente.": "Poistetut valikot säilytetään Roskakorissa 30 päivän ajan. Tämän jälkeen ne poistetaan pysyvästi.",
    "tutorial.Salvar edições de usuário": "Tallenna käyttäjän muutokset",
    "tutorial.Depois de completar o cadastro dos usuários, clique em Salvar.": "Kun olet täydentänyt käyttäjien tiedot, napsauta Tallenna.",
    "tutorial.Criar menu": "Luo valikko",
    "tutorial.Para criar e personalizar um menu, clique em Criar Menu e preencha as informações necessárias no modal. Você pode editar um menu a qualquer momento.": "Luodaksesi ja mukauttaaksesi valikon napsauta Luo valikko ja täytä tarvittavat tiedot ponnahdusikkunassa. Voit muokata valikkoa milloin tahansa.",
    "tutorial.Importar menu": "Tuo valikko",
    "tutorial.Para importar um menu, clique em Importar Menu e selecione o modelo e versão do equipamento.": "Tuodaksesi valikon napsauta Tuo valikko ja valitse laitteen malli ja versio.",
    "tutorial.Criar grupo": "Luo ryhmä",
    "tutorial.Para organizar suas receitas em grupos, clique em Criar Grupo e preencha as informações necessárias no modal.": "Järjestääksesi reseptisi ryhmiin napsauta Luo ryhmä ja täytä tarvittavat tiedot ponnahdusikkunassa.",
    "tutorial.Tipos de usuário": "Käyttäjätyypit",
    "tutorial.Agora você também pode criar tipos de usuários com permissões específicas para atender melhor a sua organização.": "Voit nyt myös luoda käyttäjätyyppejä, joilla on omat käyttöoikeudet organisaatiosi tarpeiden mukaisesti.",
    "tutorial.Gerenciamento de contas": "Tilien hallinta",
    "tutorial.Se caso outra pessoa da sua organização também migrou a conta principal da empresa, aqui você pode unir as duas contas.": "Jos joku muu organisaatiostasi on myös siirtänyt yrityksen päätilin, voit yhdistää nämä kaksi tiliä täällä.",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Grupo.": "Täydentääksesi laitteidesi tiedot avaa sivuvalikko, napsauta Muokkaa ja täytä Ryhmä-tiedot.",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente ao Grupo de equipamentos a qual ele faz parte.": "Täydentääksesi käyttäjien tiedot avaa sivuvalikko, napsauta Muokkaa ja täytä tiedot laitteiden ryhmästä, johon käyttäjä kuuluu.",
    "tutorial.Grupos de equipamentos": "Laiteryhmät",
    "tutorial.Na aba Grupos você pode visualizar os grupos cadastrados e os equipamentos distribuídos entre eles. Além disso, é possível cadastrar novos grupos e editar os já cadastrados.": "Ryhmät-välilehdellä voit tarkastella rekisteröityjä ryhmiä ja niihin kuuluvia laitteita. Voit myös luoda uusia ryhmiä ja muokata olemassa olevia.",
    "tutorial.Detalhes de grupos": "Ryhmän tiedot",
    "tutorial.Para visualizar mais informações sobre o grupo, como localização e receitas mais preparadas, clique sobre a linha que deseja analisar.": "Napsauta haluamasi ryhmän riviä nähdäksesi lisätietoja, kuten sijainnin ja eniten valmistetut reseptit.",
    "tutorial.Equipamentos em grupos": "Ryhmien laitteet",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em um grupo, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Napsauttamalla ryhmään rekisteröidyn laitteen riviä voit tarkastella lisätilastoja ja -tietoja sekä pyytää huoltoa tai lähettää päivityksiä.",
    "tutorial.Grupos": "Ryhmät",
    "tutorial.Atualização e cache": "Päivitys ja välimuisti",
    "tutorial.Para atualizar a plataforma e corrigir eventuais problemas de cache, clique aqui.": "Päivittääksesi alustan ja korjataksesi mahdolliset välimuistiongelmat napsauta tästä.",
    "tutorial.Dados dos equipamentos": "Laitetiedot",
    "tutorial.Ao clicar sobre a linha de um equipamento, você pode visualizar mais estatísticas e informações sobre ele, como as receitas mais preparadas, limpezas realizadas e outros dados relevantes.": "Napsauttamalla laitteen riviä voit tarkastella lisätilastoja ja -tietoja, kuten eniten valmistetut reseptit, suoritetut puhdistukset ja muita olennaisia tietoja.",
    "tutorial.Para alterar o idioma de sua plataforma, clique em Idioma e selecione a linguagem desejada.": "Vaihtaaksesi alustan kielen napsauta Kieli ja valitse haluamasi kieli.",
    "tutorial.Alterar idioma": "Vaihda kieli",
    "tutorial.Para editar ou configurar sua conta, clique em seu nome e selecione a opção desejada.": "Muokataksesi tai määrittääksesi tilisi napsauta nimeäsi ja valitse haluamasi toiminto.",
    "tutorial.Editar conta": "Muokkaa tiliä",
    "tutorial.Total de Usuários Cadastrados em sua conta.": "Tilillesi rekisteröityjen käyttäjien kokonaismäärä.",
    "tutorial.Home": "Etusivu",
    "tutorial.Localização de seus equipamentos, sendo possível expandir o mapa para melhor visualização;": "Laitteidesi sijainti; karttaa voidaan suurentaa paremman näkyvyyden saavuttamiseksi.",
    "tutorial.Atualizações referentes a versão dos equipamentos vinculados a sua conta;": "Tilillesi liitettyjen laitteiden versiopäivitykset.",
    "tutorial.Total de Receitas Cadastradas;": "Rekisteröityjen reseptien kokonaismäärä.",
    "tutorial.Menus Disponíveis;": "Saatavilla olevat valikot.",
    "tutorial.Esta é a sua home! Aqui você encontra um resumo geral sobre sua conta;": "Tämä on etusivusi! Täältä löydät yleiskatsauksen tilistäsi.",
    "tutorial.Clique nas abas do menu para explorar a plataforma e conhecer tudo o que ela pode oferecer.": "Tutustu alustaan ja sen kaikkiin ominaisuuksiin napsauttamalla valikon välilehtiä.",
    "tutorial.Exportar menu": "Vie valikko",
    "tutorial.Depois de personalizar seu menu, exporte-o para seus equipamentos pela internet ou USB-muistitikun kautta.": "Kun olet mukauttanut valikkosi, vie se laitteillesi internetin tai USB-muistitikun kautta.",
    "tutorial.Na aba Localização você pode visualizar os endereços já cadastrados, além de criar localizações precisas para vincular seus equipamentos a elas.": "Sijainti-välilehdellä voit tarkastella jo rekisteröityjä osoitteita sekä luoda tarkkoja sijainteja laitteidesi liittämistä varten.",
    "tutorial.Localização": "Sijainti",
    "tutorial.Informações sobre o equipamento": "Laitteen tiedot",
    "tutorial.Equipamentos Ligados e quantos estão enviando dados de uso;": "Käynnissä olevat laitteet ja kuinka moni niistä lähettää käyttötietoja.",
    
    //RECOVER ACCOUNT
    "recoverAccount.Para prosseguir, selecione a categoria na qual você se encaixa:": "Jatka valitsemalla sinua vastaava kategoria:",
    "recoverAccount.Deseja acessar a plataforma como DISTRIBUIDOR? Crie sua conta clicando em EMPRESA e entre em contato conosco para vapautarmos os demais acessos.": "Haluatko käyttää alustaa JAKELIJANA? Luo tili napsauttamalla YRITYS ja ota meihin yhteyttä, jotta voimme ottaa käyttöön muut käyttöoikeudet.",
    "recoverAccount.A qual organização você pertence": "Mihin organisaatioon kuulut?",
    
    //RECOVER PASSWORD PAGE
    "recoverPassword.E-mail para recuperação de senha": "Salasanan palautussähköposti",
    "recoverPassword.Informe o e-mail cadastrado na plataforma": "Anna alustalle rekisteröity sähköpostiosoite",
    "recoverPassword.E-mail inválido. Por favor, verifique": "Virheellinen sähköpostiosoite. Tarkista tiedot.",
    "recoverPassword.RECUPERAR SENHA": "PALAUTA SALASANA",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL COM O LINK DE RECUPERAÇÃO DE SENHA":
    "Saat pian sähköpostin, jossa on linkki salasanan palauttamista varten.",
    "recoverPassword.Informe seu e-mail": "Anna sähköpostiosoitteesi",
    "recoverPassword.Crie uma nova senha": "Luo uusi salasana",
    "recoverPassword.O campo senha deve conter no mínimo 6 caracteres":
    "Salasanassa on oltava vähintään 6 merkkiä",
    "recoverPassword.Confirme sua senha": "Vahvista salasanasi",
    "recoverPassword.As senhas devem ser iguais": "Salasanojen on oltava samat",
    "recoverPassword.ENTRAR": "KIRJAUDU SISÄÄN",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE": "Saat pian sähköpostin henkilöllisyytesi vahvistamista varten.",
    "recoverPassword.CONTINUAR": "JATKA",
    "recoverPassword.CONFIRMAR": "VAHVISTA",
    "recoverPassword.Por segurança, o acesso à conta foi bloqueado devido a tentativas de login incorretas.": "Turvallisuussyistä tilisi käyttö on estetty virheellisten kirjautumisyritysten vuoksi.",
    "recoverPassword.Para desbloquear sua conta, siga as instruções após clicar no botão abaixo:": "Poistaaksesi tilin lukituksen noudata ohjeita napsautettuasi alla olevaa painiketta:",
    "recoverPassword.Desbloquear conta": "Poista tilin lukitus",
    "recoverPassword.Você recebeu um e-mail para iniciar o desbloqueio de sua conta.": "Sinulle on lähetetty sähköposti tilisi lukituksen avaamisen aloittamiseksi.",
    "recoverPassword.Verifique sua caixa de entrada ou spam.": "Tarkista saapuneet viestit tai roskapostikansio.",
    "recoverPassword.Verifique seu e-mail": "Tarkista sähköpostisi",
    "recoverPassword.Informe seu e-mail de login e crie uma nova senha para acessar sua conta.": "Anna kirjautumissähköpostiosoitteesi ja luo uusi salasana käyttääksesi tiliäsi.",
    
    
    
    
    // EXPORT
    "export.Limpezas": "Puhdistukset",
    "export.Eventos": "Tapahtumat",
    "export.Lista de receitas preparadas": "Valmisteltujen reseptien luettelo",
    "export.Lista de limpezas realizadas": "Suoritettujen puhdistusten luettelo",
    "export.Lista de eventos ocorridos": "Tapahtumaluettelo",
    "export.Exportar dados": "Vie tiedot",
    "export.Exportar": "Vie",
    "export.Informações do equipamento": "Laitteen tiedot",
    "export.Dados exportados com sucesso!": "Tiedot vietiin onnistuneesti!",
    "export.Não foi possível exportar os dados. Por favor, tente novamente mais tarde.": "Tietojen vienti epäonnistui. Yritä myöhemmin uudelleen.",
    "export.Detalhes do menu": "Valikon tiedot",
    "export.Detalhes de receitas": "Reseptien tiedot",
    "export.Detalhes e Passos": "Tiedot ja vaiheet",
    "export.Exportando dados. Em breve o arquivo estará disponível!": "Tietoja viedään. Tiedosto on pian saatavilla!",
    "export.Resumo dos passos": "Vaiheiden yhteenveto",
    "export.salvar imagem": "tallenna kuva",
    "export.Nenhum modelo foi selecionado": "Yhtään mallia ei ole valittu",
    
    // COMPANIES PAGE
    "company.Procurar companhia": "Etsi yritystä",
    "company.Adicionar companhia": "Lisää yritys",
    "company.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "YRITYKSIÄ EI OLE VIELÄ REKISTERÖITY :(",
    "company.description.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "Napsauta oikeassa yläkulmassa olevaa painiketta lisätäksesi yrityksiä.",
    "company.Adicionar": "Lisää",
    "company.ADICIONAR EQUIPAMENTOS": "LISÄÄ LAITTEITA",
    "company.Preencha pelo menos um número de série": "Anna vähintään yksi sarjanumero",
    "company.Informe os números de série": "Anna sarjanumerot",
    "company.Número de série": "Sarjanumero",
    "company.Para incluir vários equipamentos, separe-os com ponto e vírgula (;).": "Lisätäksesi useita laitteita erottele ne puolipisteellä (;).",
    "company.Informe o número de série do equipamento que deseja adicionar abaixo.": "Anna alla lisättävän laitteen sarjanumero.",
    "company.Números de série adicionados com sucesso!": "Sarjanumerot lisättiin onnistuneesti!",
    "company.Não foi possível adicionar os números de série. Tente novamente mais tarde": "Sarjanumeroiden lisääminen epäonnistui. Yritä myöhemmin uudelleen.",
    "company.adicionar": "lisää",
    "company.Procurar por companhia ou ID": "Etsi yritystä tai tunnusta",
    "company.Companhia": "Yritys",
    "company.E-mail principal": "Pääsähköpostiosoite",
    "company.Local": "Sijainti",
    "company.Companhia adicionada com sucesso!": "Yritys lisättiin onnistuneesti!",
    "company.Não foi possível cadastrar a companhia": "Yrityksen rekisteröinti epäonnistui.",
    "company.REMOVER COMPANHIA": "POISTA YRITYS",
    "company.Você deseja remover a companhia definitivamente? Os equipamentos vinculados a ela também serão removidos de sua conta.": "Haluatko poistaa yrityksen pysyvästi? Myös siihen liitetyt laitteet poistetaan tililtäsi.",
    "company.Esta ação não poderá ser desfeita.": "Tätä toimintoa ei voi kumota.",
    "company.A companhia foi removida com sucesso!": "Yritys poistettiin onnistuneesti!",
    "company.Não foi possível remover a companhia": "Yrityksen poistaminen epäonnistui.",
    "company.Quant. de fornos": "Uunien määrä",
    "company.Fornos conectados": "Yhdistetyt uunit",
    "company.Fornos não conectados": "Yhdistämättömät uunit",
    "company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "LAITTEITA EI OLE VIELÄ REKISTERÖITY :(",
    "company.description.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "Lisää laitteita napsauttamalla oikeassa yläkulmassa olevaa painiketta.",
    "company.Procurar número de série": "Etsi sarjanumerolla",
    "company.excluir equipamento": "poista laite",
    "company.Você deseja excluir o equipamento selecionado definitivamente?": "Haluatko poistaa valitun laitteen pysyvästi?",
    "company.Número de série editado com sucesso!": "Sarjanumero päivitettiin onnistuneesti!",
    "company.Não foi possível editar o número de série. Tente novamente mais tarde": "Sarjanumeron muokkaaminen epäonnistui. Yritä myöhemmin uudelleen.",
    "company.Informe o número de série": "Anna sarjanumero",
    "company.Preencha um número de série": "Anna sarjanumero",
    "company.EDITAR EQUIPAMENTO": "MUOKKAA LAITETTA",
    "company.Modelo": "Malli",
    "company.Cadastro": "Rekisteröinti",
    "company.Conectado": "Yhdistetty",
    "company.SELECIONE EQUIPAMENTOS PARA EXCLUIR": "VALITSE POISTETTAVAT LAITTEET",
    "company.O equipamento foi removida com sucesso!": "Laite poistettiin onnistuneesti!",
    "company.Não foi possível remover o equipamento": "Laitteen poistaminen epäonnistui.",
    "company.Caracteres especiais não são permitidos, exceto o ponto e vírgula (';')": "Erikoismerkit eivät ole sallittuja puolipistettä (';') lukuun ottamatta.",
    "company.Preencha o número de série sem caracteres especiais": "Anna sarjanumero ilman erikoismerkkejä.",
    "company.Um ou mais números de série já estão provisionados para outra companhia": "Yksi tai useampi sarjanumero on jo varattu toiselle yritykselle.",
    "company.Um ou mais números de série já estão conectados na conta de outra companhia": "Yksi tai useampi sarjanumero on jo liitetty toisen yrityksen tiliin.",
    
    // Error
    "error.Ocorreu um erro ao carregar esta seção": "Tämän osion lataamisessa tapahtui virhe.",
    "error.Tentar novamente": "Yritä uudelleen",
    
    // DASHBOARDS
    "dashboard.fornos vinculados": "LIITETYT UUNIT",
    "dashboard.ativos": "Aktiiviset",
    "dashboard.inativos": "Ei aktiiviset",
    "dashboard.sem status": "Ei tilaa",
    "dashboard.fornos atualizados": "PÄIVITETYT UUNIT",
    "dashboard.com a versão do software mais recente": "Käyttävät uusinta ohjelmistoversiota",
    "dashboard.chamados": "HUOLTOPYYNNÖT",
    "dashboard.veja mais no app cliente": "Katso lisää Asiakas-sovelluksesta",
    "dashboard.limpeza diária": "PÄIVITTÄINEN PUHDISTUS",
    "dashboard.dos fornos estão em dia": "uuneista on puhdistettu ajallaan",
    "dashboard.top 3": "Top 3",
    "dashboard.média de execuções de receitas por hora": "Reseptien valmistusten keskimääräinen määrä tunnissa",
    "dashboard.avisos": "ILMOITUKSET",
    "dashboard.sem avisos por aqui": "EI ILMOITUKSIA",
    "dashboard.ver mais": "Näytä lisää",
    "dashboard.abertos pela plataforma IOK": "Avattu IOK-alustalla",
    "dashboard.equipamentos": "Laitteet",
    "dashboard.receitas": "Reseptit",
    "dashboard.executada": "valmistettu",
    "dashboard.vezes": "kertaa",
    "dashboard.forno": "Uuni",
    "dashboard.média por hora": "Keskiarvo tunnissa",
    "dashboard.editar": "muokkaa",
    "dashboard.endereço:": "Osoite:",
    "dashboard.cep:": "Postinumero:",
    "dashboard.estatísticas": "Tilastot",
    "dashboard.uso de equipamento": "Laitteen käyttö",
    "dashboard.pico de uso": "Käytön huippu",
    "dashboard.receitas mais executadas por equipamento": "Laitteella eniten valmistetut reseptit",
    "dashboard.recolher": "supista",
    "dashboard.TOROS TC CONECTADOS:": "YHDISTETYT TOROS TC -UUNIT:",
    "dashboard.Consumo de energia - Lastro Toro TC": "Energiankulutus - Lastro Toro TC",
    "dashboard.tootilp": "Nykyisen päivän kaikkien valmistettujen reseptien summa jaettuna sillä tuntimäärällä, jonka uuni on ollut päällä.",
    "dashboard.noResults": "Tuloksia ei löytynyt :(",
    "dashboard.Preaquecimento": "Esilämmitys",
    "dashboard.Esfriamento": "Jäähdytys",
    "dashboard.Execução de receitas": "Reseptien valmistus",
    "dashboard.Execução de receitas TSi": "TSi-reseptien valmistus",
    "dashboard.Modo manual": "Manuaalinen tila",
    "dashboard.Limpeza": "Puhdistus",
    "dashboard.Porta": "Ovi",
    "dashboard.Erros e alertas": "Virheet ja hälytykset",
    "dashboard.Parâmetros": "Parametrit",
    "dashboard.SEM DADOS POR AQUI": "EI TIETOJA TÄÄLLÄ",
    "dashboard.AINDA SEM GRÁFICOS POR AQUI": "EI VIELÄ KAAVIOITA TÄÄLLÄ",
    "dashboard.description.AINDA SEM GRÁFICOS POR AQUI": "Valitse kohteita viereisestä luettelosta luodaksesi kaavioita tai napsauta riviä nähdäksesi lisätiedot.",
    
    
    // INFORMAÇÕES IOK
    "iokInformation.search.placeholder": "Hae artikkelia",
    "iokInformation.article.openInHelpCenter": "Näytä artikkeli ohjekeskuksessa",
    "iokInformation.aboutPlatform.platformFeatures.title": "Alusta ja sen ominaisuudet",
    "iokInformation.aboutPlatform.platformFeatures.linkLabel": "Lataa koko esitys",
    "iokInformation.aboutPlatform.manual.title": "Käyttöohje",
    "iokInformation.aboutPlatform.manual.linkLabel": "Lataa käyttöohje",
    "iokInformation.aboutPlatform.privacy.title": "Tietosuojakäytäntö",
    "iokInformation.aboutPlatform.privacy.linkLabel": "Lataa tietosuojakäytäntö",
    "iokInformation.aboutPlatform.api.title": "Ulkoinen API",
    "iokInformation.aboutPlatform.api.linkLabel": "Lataa asiakirja",
    
    //Telemetry TSI
    "telemetry.EQUIPMENT_TURN_ON": "Laite käynnistetty",
    "telemetry.SENSORS_VALUES": "Anturiarvot",
    "telemetry.ERROR_DETECTED": "Virhe havaittu",
    "telemetry.TIME_ADDED": "Aikaa lisätty",
    "telemetry.GN_ADDED": "GN lisätty",
    "telemetry.GN_RELEASED": "GN käynnistetty",
    "telemetry.GN_FINISHED": "GN valmis",
    
    "telemetry.HEAVY_CLEANING_CANCELED": "Tehopuhdistus peruutettu",
    "telemetry.CLEANING_CANCELED": "Puhdistus peruutettu",
    "telemetry.CLEANING_RESTARTED": "Puhdistus käynnistetty uudelleen",
    "telemetry.CLEANING_VAPORIZATION_STEP": "Puhdistuksen höyrystysvaihe",
    "telemetry.CLEANING_SUPPLY_STEP": "Puhdistuksen täyttövaihe",
    "telemetry.CLEANING_CIRCULATION_STEP": "Puhdistuksen kiertovaihe",
    "telemetry.CLEANING_DEPLETION_STEP": "Puhdistuksen tyhjennysvaihe",
    "telemetry.CLEANING_RISING_STEP": "Puhdistuksen huuhteluvaihe",
    "telemetry.CLEANING_STARTED": "Puhdistus aloitettu",
    "telemetry.CLEANING_FINISHED": "Puhdistus valmis",
    "telemetry.RECOMMENDED_CLEANING": "Suositeltu puhdistus",
    "telemetry.VALID_PASSWORD_CLEANING": "Kelvollinen salasana puhdistuksessa",
    "telemetry.INVALID_PASSWORD_CLEANING": "Virheellinen salasana puhdistuksessa",
    
    "telemetry.RECIPE_STARTED": "Reseptin valmistus aloitettu",
    "telemetry.RECIPE_FINISHED": "Reseptin valmistus valmis",
    "telemetry.RECIPE_CANCELED": "Reseptin valmistus peruutettu",
    "telemetry.RECIPE_STEP_CHANGED": "Reseptin vaihe muutettu",
    "telemetry.RECIPE_PAUSED": "Reseptin valmistus keskeytetty",
    "telemetry.RECIPE_RESUMED": "Reseptin valmistusta jatkettu",
    "telemetry.DROP_ENERGY_SUPPLY": "Jatkettu sähkökatkon jälkeen",
    "telemetry.RESUME_RECIPE_CANCELED": "Reseptin valmistuksen jatkaminen peruutettu",
    
    "telemetry.PRE_HEAT_STARTED": "Esilämmitys aloitettu",
    "telemetry.PRE_HEAT_FINISHED": "Esilämmitys valmis",
    "telemetry.OPERATION_CONTINUE_STARTED": "Toiminnon jatkaminen aloitettu",
    "telemetry.OPERATION_CONTINUE_FINISHED": "Toiminnon jatkaminen valmis",
    "telemetry.HOLD_TEMPERATURE_STARTED": "Lämpötilan ylläpito aloitettu",
    "telemetry.HOLD_TEMPERATURE_FINISHED": "Lämpötilan ylläpito valmis",
    "telemetry.COOL_DOWN_STARTED": "Jäähdytys aloitettu",
    "telemetry.COOL_DOWN_FINISHED": "Jäähdytys valmis",
    "telemetry.NOCTURNAL_COOKING_STARTED": "Yökypsennys aloitettu",
    "telemetry.NOCTURNAL_COOKING_FINISHED": "Yökypsennys valmis",
    "telemetry.SEALING_STARTED": "Paahtaminen aloitettu",
    "telemetry.SEALING_FINISHED": "Paahtaminen valmis",
    "telemetry.TURBO_GRILL_STARTED": "Turbo Grill aloitettu",
    "telemetry.TURBO_GRILL_FINISHED": "Turbo Grill valmis",
    "telemetry.TURBO_GRILL_ACTIVATED": "Turbo Grill aktivoitu",
    "telemetry.TURBO_GRILL_DISABLED": "Turbo Grill poistettu käytöstä",
    
    "telemetry.MOISTURE_CHANGED": "Kosteus muutettu",
    "telemetry.TURBINE_CHANGED": "Puhaltimen arvo muutettu",
    "telemetry.SET_POINT_CHANGED": "Kammion lämpötila muutettu",
    "telemetry.STEAM_CHANGED": "Höyry muutettu",
    "telemetry.PROBE_CHANGED": "Paistolämpömittarin lämpötila muutettu",
    "telemetry.TIME_CHANGED": "Aika muutettu",
    "telemetry.DOOR_OPENED": "Ovi avattu",
    "telemetry.DOOR_CLOSED": "Ovi suljettu",
    
    "telemetry.PROBE_CONTROL_SELECTED": "Paistolämpömittariohjaus valittu",
    "telemetry.TIME_CONTROL_SELECTED": "Aikaohjaus valittu",
    "telemetry.MANUAL_STEAM_INJECTED": "Manuaalinen höyryruiskutus",
    "telemetry.AUTOMATIC_STEAM_INJECTED": "Automaattinen höyryruiskutus",
    
    "telemetry.DATABASE_CREATED": "Tietokanta luotu",
    "telemetry.EXIT_FUNCTION": "Toiminto päättynyt",
    "telemetry.CONSUMPTION": "Kulutus",
    "telemetry.STANDBY": "Valmiustila",
    
    "telemetry.ANALYTICS_ERROR_BAD_REQUEST": "Analytiikkavirhe: Virheellinen pyyntö",
    "telemetry.ANALYTICS_ERROR_FORBIDDEN": "Analytiikkavirhe: Käyttö estetty",
    "telemetry.ANALYTICS_ERROR_SERVER": "Analytiikkavirhe: Palvelinvirhe",
    "telemetry.ANALYTICS_ERROR_UNEXPECTED": "Analytiikkavirhe: Odottamaton virhe",
    "telemetry.ANALYTICS_SUCCESS": "Analytiikka onnistui",
    
    "telemetry.STEP": "Vaihe",
    "telemetry.STEAM": "Höyry",
    "telemetry.PROBE": "Paistolämpömittari",
    "telemetry.TURBINE": "Puhallin",
    "telemetry.OCCURRENCES": "esiintymä(ä)",
    "telemetry.FUNC_USER_RECIPE": "Käyttäjän resepti",
    "telemetry.FUNC_TSI_RECIPE": "TSi-resepti",
    "telemetry.FUNC_DELTA_T": "Delta T",
    "telemetry.FUNC_STEAM": "Höyry",
    "telemetry.FUNC_COMBINED_STEAM": "Yhdistelmähöyry",
    "telemetry.FUNC_HOT_AIR": "Kuuma ilma",
    "telemetry.FUNC_NOCTURNAL_COOKING": "Yökypsennys",
    "telemetry.FUNC_REGENERATE": "Regenerointi",
    "telemetry.FUNC_MULTIPLE_COOKING": "Monikypsennys",
    
    "haccp.filterBy": "Suodata",
    "haccp.export.generating": "HACCP-laskentataulukkoa luodaan ja se ladataan automaattisesti pian.",
    "haccp.voltage": "Jännite",
    "haccp.voltageReading": "Jännitteen lukema",
    "haccp.voltageOscillation": "Päivän jännitevaihtelu",
    "haccp.status.normal": "Normaali",
    "haccp.status.attention": "Huomio",
    "haccp.status.critical": "Kriittinen",
    "haccp.dateTime": "Päivämäärä/Aika",
    "haccp.errorDetected": "Virhe/Hälytys havaittu",
    "haccp.detected": "havaittu",
    "haccp.errorTypeLabel": "Virheen/hälytyksen tyyppi",
    "haccp.severityLabel": "Vakavuus",
    "haccp.severity.error": "Virhe",
    "haccp.severity.alert": "Hälytys",
    "haccp.error.canNetwork": "CAN-verkkovirhe",
    "haccp.error.chamberSensor": "Kammion anturivirhe",
    "haccp.error.steamSensor": "Höyryanturin virhe",
    "haccp.error.probeSensor": "Paistolämpömittarin virhe",
    "haccp.error.noWater": "Vedenpuutevirhe",
    "haccp.error.panelTemp": "Paneelin lämpötilavirhe",
    "haccp.error.motor": "Moottorivirhe",
    "haccp.error.motorComm": "Moottorin tiedonsiirtovirhe",
    "haccp.error.hygieneIncomplete": "Puutteellinen puhdistus",
    "haccp.error.familyModel": "Laitesarjan/mallin virhe",
    "haccp.error.boardTemp": "Piirilevyn lämpötilavirhe",
    "haccp.error.energyModule": "Energiamoduulin virhe",
    "haccp.error.i2c": "I2C-virhe",
    "haccp.error.gas": "Kaasuvirhe",
    "haccp.loading": "Ladataan...",
    "haccp.quantity": "Määrä",
    "haccp.executions": "Valmistukset",
    "haccp.manual.mode": "Tila",
    "haccp.manual.tempC": "Lämpötila (°C)",
    "haccp.manual.timeMin": "Aika (min)",
    "haccp.manual.probeC": "Paistolämpömittari (°C)",
    "haccp.manual.steamPct": "Höyry %",
    "haccp.cleaning.label": "Puhdistus",
    "haccp.cleaning.recommendedLabel": "Suositeltu puhdistus",
    "haccp.cleaning.status.completed": "Valmis",
    "haccp.cleaning.status.restarted": "Käynnistetty uudelleen",
    "haccp.cleaning.status.interrupted": "Keskeytetty",
    "haccp.status.label": "Tila",
    "haccp.error": "Virhe",
    "haccp.consumption.water": "Vedenkulutus",
    "haccp.consumption.energy": "Energiankulutus",
    "haccp.short.temp": "Lämp.",
    "haccp.short.time": "Aika",
    "haccp.day": "Päivä",
    "haccp.recipeExecutions": "Valmistuskerrat",
    "STEAM": "Höyry",
    "COMBINED_STEAM": "Yhdistelmähöyry",
    "PROBE": "Paistolämpömittari",
    "TURBINE": "Puhallin",
    "HOT_AIR": "Kuuma ilma",
    "NOCTURNAL_COOKING": "Yökypsennys",
    "REGENERATE": "Regenerointi",
    "MULTIPLE_COOKING": "Monikypsennys",
    "DELTA_T": "Delta T",
    
    //CSAT
    "csat.AVALIE SUA EXPERIÊNCIA": "ARVIOI KOKEMUKSESI",
    "csat.Como você avalia sua experiência com": "Miten arvioit kokemuksesi liittyen",
    "csat.Muito insatisfeito": "Erittäin tyytymätön",
    "csat.Insatisfeito": "Tyytymätön",
    "csat.Neutro": "Neutraali",
    "csat.Satisfeito": "Tyytyväinen",
    "csat.Muito satisfeito": "Erittäin tyytyväinen",
    "csat.Utilize o espaço abaixo para deixar suas sugestões:": "Kirjoita ehdotuksesi alle:",
    "csat.Digite aqui": "Kirjoita tähän",
    "csat.Obrigado por responder à nossa pesquisa!": "Kiitos vastauksestasi kyselyymme!",
    "csat.Selecione uma nota para continuar": "Valitse arvosana jatkaaksesi",
    "csat.Enviar": "Lähetä",
    "csat.a criação de receitas": "reseptien luominen",
    "csat.o cadastro de equipamentos": "laitteiden rekisteröinti",
    "csat.o cadastro de usuários": "käyttäjien rekisteröinti",
    "csat.a criação de menus": "valikoiden luominen",
    "csat.a deleção de receitas": "reseptien poistaminen",
    "csat.a reordenação de receitas": "reseptien uudelleenjärjestely",
    "csat.o envio de software": "ohjelmistopäivitysten lähettäminen",
    "csat.o envio de menus": "valikoiden lähettäminen",
    "csat.o uso de receitas do Cookbook": "Cookbook-reseptien käyttö",
  },
};

export default fi;


